import React, { Component } from 'react';
import $ from 'jquery';
import format from 'string-format';
import { Form, EmptyItem, SimpleItem, ButtonItem, ButtonOptions } from 'devextreme-react/form';

import Calculator from '../../utils/calculator';
import AntCondition from '../../utils/AntCondition';
import AntLocalStorage from '../../utils/AntLocalStorage';
import AntTime from '../../utils/AntTime';
import AntConfig from '../../utils/AntConfig';
import AntLocalization from '../../utils/AntLocalization';
import { ValidationGroup } from 'devextreme-react/validation-group';
import { Validator } from 'devextreme-react/validator';
import { Template } from 'devextreme-react/core/template';
import { TextBox, CheckBox, SelectBox, TextArea, NumberBox, DateBox } from 'devextreme-react';

import { Button as TextBoxButton } from 'devextreme-react/text-box';
import ValidationEngine from 'devextreme/ui/validation_engine';

import AntFilterBuilder from '../AntFilterBuilder';
import AntSelectBox from '../AntSelectBox';
import AntTagBox from '../AntTagBox';
import AntDropDownGrid from '../AntDropDownGrid';
import AntDropDownTree from '../AntDropDownTree';
import AntMonthBox from '../AntMonthBox';
import AntYearBox from '../AntYearBox';
import AntAddress from '../../utils/AntAddress';
import AntCategory from '../../utils/AntCategory';

export default class extends Component {
    constructor(props) {
        super(props);

        var tableName = this.props.table ? this.props.table : this.props.API ? this.props.API.entityName : null;
        this.config = new AntConfig(this.props.session, tableName);
        this.config.configFields(this.props.fields);

        this.state = {
            tableName: tableName,
            items: [],
            oldData: { ...this.props.formData, edit: undefined },
            formData: this.props.formData,
            formLookups: [],
            dataSources: []
        };
        this.API = this.props.API;

        this.AddressData = new AntAddress(this.props.session.appAssets.data.addressData);
        this.CategoryData = new AntCategory(this.props.session.appAssets.data.categoryData);

        this.isHadNewData = this.isHadNewData.bind(this);
        this.load = this.load.bind(this);
        this.validate = this.validate.bind(this);
        this.initItems = this.initItems.bind(this);
        this.initDefaultValues = this.initDefaultValues.bind(this);
        this.resetUI = this.resetUI.bind(this);
        this.resetVisibility = this.resetVisibility.bind(this);
        this.resetDefaultValue = this.resetDefaultValue.bind(this);
        this.resetDisabled = this.resetDisabled.bind(this);
        this.resetColSpan = this.resetColSpan.bind(this);
        this.renderItem = this.renderItem.bind(this);
        this.validateItem = this.validateItem.bind(this);

        this.onFieldDataChanged = this.onFieldDataChanged.bind(this);
        this.isDisableField = this.isDisableField.bind(this);
        this.isValidatableField = this.isValidatableField.bind(this);
        this.isVisibleField = this.isVisibleField.bind(this);
        this.isRenderField = this.isRenderField.bind(this);
        this.getDefaultFieldValue = this.getDefaultFieldValue.bind(this);
        this.getChangedFields = this.getChangedFields.bind(this);
        this.getId = this.getId.bind(this);
        this.getChecksum = this.getChecksum.bind(this);
        this.getFormData = this.getFormData.bind(this);
        this.setField = this.setField.bind(this);
        this.getField = this.getField.bind(this);
        this.onAction = this.onAction.bind(this);

        this.getDataSource = this.getDataSource.bind(this);
        this.setDataSource = this.setDataSource.bind(this);

        this.updateDimensions = this.updateDimensions.bind(this);
        this.beginUpdate = this.beginUpdate.bind(this);
        this.endUpdate = this.endUpdate.bind(this);

        this.isFocusableField = this.isFocusableField.bind(this);
        this.getFirstFocusableField = this.getFirstFocusableField.bind(this);

        var getItem = (items, parent, parentIndex) => {
            var ar = [];
            if (items instanceof Array) {
                items.forEach((e, i) => {
                    if (e.items instanceof Array) ar.push(...getItem(e.items, e, i));
                    else {
                        if (typeof e === 'object') {
                            if (e.itemType !== 'empty' && e.itemType !== 'group')
                                ar.push({
                                    ...e,
                                    groupIndex: parent && parentIndex !== undefined ? parentIndex : undefined,
                                    groupName: parent && parent.name ? parent.name : undefined,
                                    groupLabel: parent && parent.label ? parent.label : undefined
                                });
                        } else if (typeof e === 'string')
                            ar.push({
                                dataField: e,
                                groupIndex: parent && parentIndex !== undefined ? parentIndex : undefined,
                                groupName: parent && parent.name ? parent.name : undefined,
                                groupLabel: parent && parent.label ? parent.label : undefined
                            });
                    }
                });
            }
            return ar;
        };

        if (this.props.items instanceof Array) this.state.rawItems = getItem(this.props.items);
    }

    beginUpdate() {
        if (this.form) this.form.beginUpdate();
    }

    endUpdate() {
        if (this.form) this.form.endUpdate();
    }
    updateDimensions() {
        if (this.form) this.form.updateDimensions();
    }

    async isHadNewData(id, code) {
        if (!id && !code) return;

        var that = this;

        var oldChecksum = this.state.formData && this.state.formData.checksum ? this.state.formData.checksum : undefined;

        return new Promise(async (resolve) => {
            var obj = null;
            if (that.props.prepare !== false && that.API && that.API.postGetChecksum) obj = await that.API.postGetChecksum(id, code);

            resolve(obj && obj.checksum !== oldChecksum);
        });
    }

    async load(id, code, recalcable) {
        if (!id && !code) return;

        var that = this;

        return new Promise(async (resolve) => {
            that.beginUpdate();

            var obj = null;
            if (that.props.prepare !== false && that.API && that.API.postUpdatePrepare) {
                obj = await that.API.postUpdatePrepare(id, code, Boolean(recalcable), that.props.prepareConditions);
            }
            if (obj && obj.error) {
                that.state.formData = { error: obj.error, errorCode: obj.code };
                await that.resetUI(true);
                if (that.props.onPrepared) that.props.onPrepared(that.state.formData);
                that.endUpdate();
                resolve(that.state.formData);
                return;
            }

            if (!obj) {
                if (!that.state.formData) that.state.formData = {};
                await that.resetUI(true);
                if (that.props.onPrepared) that.props.onPrepared(that.state.formData);
                that.endUpdate();
                resolve(that.state.formData);
                return;
            }

            if (that.state.rawItems instanceof Array) {
                that.state.rawItems.forEach((item) => {
                    if (item.dataField) {
                        var value;
                        if (item.formula instanceof Array) {
                            var fm = item.formula[0];
                            var defaultNullValue =
                                item.formula[1] !== undefined && item.formula[1] !== null && typeof item.formula[1] === 'number'
                                    ? item.formula[1]
                                    : 0;
                            value = Calculator.execNum(obj, fm, defaultNullValue);
                            obj[item.dataField] = value;
                        } else if (item.dataType === 'join') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!obj) return null;

                                        if (f === 'category1') {
                                            var cat1 = this.CategoryData.getCat1(obj[f]);
                                            if (cat1) return AntLocalization.translateText(cat1.name);
                                        }
                                        if (f === 'category2') {
                                            var cat2 = this.CategoryData.getCat2(obj[f]);
                                            if (cat2) return AntLocalization.translateText(cat2.name);
                                        }
                                        if (f === 'category3') {
                                            var cat3 = this.CategoryData.getCat3(obj[f]);
                                            if (cat3) return AntLocalization.translateText(cat3.name);
                                        }

                                        return obj[f];
                                    })

                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .join(item.separator ? item.separator : ', ');
                            }
                            obj[item.dataField] = value;
                        } else if (item.dataType === 'first') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!obj) return null;

                                        if (f === 'category1') {
                                            var cat1 = this.CategoryData.getCat1(obj[f]);
                                            if (cat1) return AntLocalization.translateText(cat1.name);
                                        }
                                        if (f === 'category2') {
                                            var cat2 = this.CategoryData.getCat2(obj[f]);
                                            if (cat2) return AntLocalization.translateText(cat2.name);
                                        }
                                        if (f === 'category3') {
                                            var cat3 = this.CategoryData.getCat3(obj[f]);
                                            if (cat3) return AntLocalization.translateText(cat3.name);
                                        }

                                        return obj[f];
                                    })
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .shift();
                            }
                            obj[item.dataField] = value;
                        } else if (item.dataType === 'last') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!obj) return null;

                                        if (f === 'category1') {
                                            var cat1 = this.CategoryData.getCat1(obj[f]);
                                            if (cat1) return AntLocalization.translateText(cat1.name);
                                        }
                                        if (f === 'category2') {
                                            var cat2 = this.CategoryData.getCat2(obj[f]);
                                            if (cat2) return AntLocalization.translateText(cat2.name);
                                        }
                                        if (f === 'category3') {
                                            var cat3 = this.CategoryData.getCat3(obj[f]);
                                            if (cat3) return AntLocalization.translateText(cat3.name);
                                        }

                                        return obj[f];
                                    })
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .pop();
                            }
                            obj[item.dataField] = value;
                        }
                    }
                });
            }

            that.setState(
                (state) => {
                    if (!state.formData) {
                        state.formData = obj;
                    } else {
                        obj = JSON.parse(JSON.stringify(obj));
                        Object.keys(state.formData).forEach(function (key) {
                            if (obj[key] === undefined) delete state.formData[key];
                        });

                        Object.keys(obj).forEach(function (key) {
                            state.formData[key] = obj[key];
                        });
                    }
                    // state.formData = obj;
                    state.formLookups = obj && obj.lookups instanceof Array ? obj.lookups : [];
                    state.oldData = {
                        ...JSON.parse(JSON.stringify(obj)),
                        edit: undefined
                    };
                    state.defaultObj = null;
                    return state;
                },
                async () => {
                    await that.resetUI(true);
                    if (that.props.onPrepared) that.props.onPrepared(that.state.formData);
                    that.endUpdate();
                    resolve(that.state.formData);
                    that.forceUpdate();
                }
            );
        });
    }

    async loadByObj(defaultObj) {
        if (!defaultObj) return;

        var id = defaultObj.id;
        var code = defaultObj.code;
        // if (!id && !code) return;

        var that = this;
        var oldDefault = JSON.parse(JSON.stringify({ ...this.props.defaultObj, ...defaultObj }));

        return new Promise(async (resolve) => {
            this.beginUpdate();

            var obj = null;
            if (that.props.prepare !== false && that.API && that.API.postUpdatePrepare && (id || code))
                obj = await that.API.postUpdatePrepare(id, code, false, that.props.prepareConditions);

            if (obj && obj.error) {
                defaultObj.error = obj.error;
                defaultObj.errorCode = obj.code;
            } else if (obj)
                Object.keys(obj).forEach(function (key) {
                    defaultObj[key] = obj[key];
                });

            obj = that.initDefaultValues();
            if (obj)
                Object.keys(obj).forEach(function (key) {
                    if (defaultObj[key] !== undefined) defaultObj[key] = obj[key];
                });

            if (that.state.rawItems instanceof Array) {
                that.state.rawItems.forEach((item) => {
                    if (item.dataField) {
                        var value;
                        if (item.formula instanceof Array) {
                            var fm = item.formula[0];
                            var defaultNullValue =
                                item.formula[1] !== undefined && item.formula[1] !== null && typeof item.formula[1] === 'number'
                                    ? item.formula[1]
                                    : 0;
                            value = Calculator.execNum(defaultObj, fm, defaultNullValue);
                            defaultObj[item.dataField] = value;
                        } else if (item.dataType === 'join') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!defaultObj) return null;

                                        if (f === 'category1') {
                                            var cat1 = this.CategoryData.getCat1(defaultObj[f]);
                                            if (cat1) return AntLocalization.translateText(cat1.name);
                                        }
                                        if (f === 'category2') {
                                            var cat2 = this.CategoryData.getCat2(defaultObj[f]);
                                            if (cat2) return AntLocalization.translateText(cat2.name);
                                        }
                                        if (f === 'category3') {
                                            var cat3 = this.CategoryData.getCat3(defaultObj[f]);
                                            if (cat3) return AntLocalization.translateText(cat3.name);
                                        }

                                        return defaultObj[f];
                                    })

                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .join(item.separator ? item.separator : ', ');
                            }
                            defaultObj[item.dataField] = value;
                        } else if (item.dataType === 'first') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!defaultObj) return null;

                                        if (f === 'category1') {
                                            var cat1 = this.CategoryData.getCat1(defaultObj[f]);
                                            if (cat1) return AntLocalization.translateText(cat1.name);
                                        }
                                        if (f === 'category2') {
                                            var cat2 = this.CategoryData.getCat2(defaultObj[f]);
                                            if (cat2) return AntLocalization.translateText(cat2.name);
                                        }
                                        if (f === 'category3') {
                                            var cat3 = this.CategoryData.getCat3(defaultObj[f]);
                                            if (cat3) return AntLocalization.translateText(cat3.name);
                                        }

                                        return defaultObj[f];
                                    })
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .shift();
                            }
                            defaultObj[item.dataField] = value;
                        } else if (item.dataType === 'last') {
                            var fields = item.fields;
                            if (fields instanceof Array) {
                                value = fields
                                    .map((f) => {
                                        if (!defaultObj) return null;

                                        if (f === 'category1') {
                                            var cat1 = this.CategoryData.getCat1(defaultObj[f]);
                                            if (cat1) return AntLocalization.translateText(cat1.name);
                                        }
                                        if (f === 'category2') {
                                            var cat2 = this.CategoryData.getCat2(defaultObj[f]);
                                            if (cat2) return AntLocalization.translateText(cat2.name);
                                        }
                                        if (f === 'category3') {
                                            var cat3 = this.CategoryData.getCat3(defaultObj[f]);
                                            if (cat3) return AntLocalization.translateText(cat3.name);
                                        }

                                        return defaultObj[f];
                                    })
                                    .filter((f) => Boolean(f))
                                    .map((f) => String(f))
                                    .pop();
                            }
                            defaultObj[item.dataField] = value;
                        }
                    }
                });
            }

            this.setState(
                (state) => {
                    state.formData = defaultObj;
                    state.oldData = {
                        ...JSON.parse(JSON.stringify(defaultObj)),
                        edit: undefined
                    };
                    state.defaultObj = JSON.parse(JSON.stringify({ ...oldDefault }));
                    return state;
                },
                async () => {
                    await that.resetUI(true);
                    // that.forceUpdate();
                    if (that.props.onPrepared) that.props.onPrepared(that.state.formData);
                    that.endUpdate();
                    return resolve(defaultObj);
                }
            );
        });
    }

    async setField(field, value, raiseEvent) {
        if (!this.state.formData) return;
        var that = this;
        var previousValue = this.state.formData[field];
        this.setState(
            (state) => {
                state.formData[field] = value;
                return state;
            },
            () => {
                if (raiseEvent !== false)
                    that.onFieldDataChanged({
                        [field]: value
                    });
            }
        );
    }

    getField(field) {
        return this.state.formData[field];
    }

    getDataSource(dataField, cmpName) {
        var old = this.state.dataSources.find((f) => (cmpName ? f.name === cmpName && f.dataField === dataField : f.dataField === dataField));
        if (old) return old.dataSource;
        return null;
    }
    setDataSource(dataField, cmpName, dataSource) {
        var old = this.state.dataSources.find((f) => (cmpName ? f.name === cmpName && f.dataField === dataField : f.dataField === dataField));
        if (!old && dataSource)
            this.state.dataSources.push({
                name: cmpName,
                dataField: dataField,
                dataSource: dataSource
            });
    }

    getId() {
        return this.state.oldData ? this.state.oldData.id : null;
    }
    getChecksum() {
        return this.state.oldData ? this.state.oldData.checksum : null;
    }

    getFormData() {
        return this.state.formData;
    }

    isValidatableField(item) {
        if (
            this.state &&
            this.state.formData &&
            this.state.formData.edit &&
            this.state.formData.edit.none_validate_fields instanceof Array &&
            this.state.formData.edit.none_validate_fields.includes(item.dataField)
        )
            return false;

        return !this.isDisableField(item);
    }

    isDisableField(item) {
        var obj = this.state.rawItems.find((e) => e.dataField === item.dataField);
        if (obj) {
            if (obj.disable === true || obj.disabled === true) return true;
            if (obj.disable === false || obj.disabled === false) return false;

            if (obj.editable === true || obj.editabled === true) return false;
            if (obj.editable === false || obj.editabled === false) return true;
        }

        if (item.dataField === 'id' && item.editorType === 'antDropDownGrid') return false;
        if (item.dataField === 'code' && item.editorType === 'antDropDownGrid') return false;

        if (!obj || obj.disable === undefined || !obj.disable.byPassCheckServer) {
            if (
                this.state &&
                this.state.formData &&
                this.state.formData.edit &&
                this.state.formData.edit.always_editable_fields instanceof Array &&
                this.state.formData.edit.always_editable_fields.includes(item.dataField)
            )
                return false;
        }

        var disabled =
            this.props.disabled === true ||
            !item ||
            ((!obj || obj.disable === undefined || !obj.disable.byPassCheckServer) &&
                (!this.state ||
                    !this.state.formData ||
                    !this.state.formData.id ||
                    !this.state.formData.edit ||
                    !this.state.formData.edit.isEditable ||
                    (this.state.formData.edit.editable_fields &&
                        this.state.formData.edit.editable_fields instanceof Array &&
                        this.state.formData.edit.editable_fields.indexOf(item.dataField) < 0 &&
                        !this.state.formData.edit.editable_fields.find((f) => typeof f === 'object' && f !== null && f.field === item.dataField))));
        if (disabled) return true;

        if (this.state.rawItems instanceof Array) {
            var obj = this.state.rawItems.find((e) => e.dataField === item.dataField);
            if (obj) {
                if (obj.disable === true || obj.disabled === true) return true;
                if (obj.disable === false || obj.disabled === false) return false;

                if (obj.editable === true || obj.editabled === true) return false;
                if (obj.editable === false || obj.editabled === false) return true;

                if (typeof obj.disable === 'object' && obj.disable !== null) {
                    if (obj.disable.type === 'self') {
                        if (obj.disable.self) {
                            var selfType = obj.disable.self.type;
                            var selfValue = this.state.formData[item.dataField];
                            var values = obj.disable.self.values;
                            var value = obj.disable.self.value;

                            if (selfType === 'diff') {
                                return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                            } else {
                                return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                            }
                        }
                    } else return AntCondition.isDisable(this.state.formData, obj);
                }

                if (typeof obj.editable === 'object' && obj.editable !== null) {
                    if (obj.editable.type === 'self') {
                        if (obj.editable.self) {
                            var selfType = obj.editable.self.type;
                            var selfValue = this.state.formData[item.dataField];
                            var values = obj.editable.self.values;
                            var value = obj.editable.self.value;

                            if (selfType === 'diff') {
                                return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                            } else {
                                return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                            }
                        }
                    } else return !AntCondition.isEditable(this.state.formData, obj);
                }
            }
        }

        if (this.config) {
            var obj = this.config.getCnfField(item.cnfField ? item.cnfField : item.dataField);

            if (!obj) return false;

            if (obj.disable === true || obj.disabled === true) return true;
            if (obj.disable === false || obj.disabled === false) return false;

            if (obj.editable === true || obj.editabled === true) return false;
            if (obj.editable === false || obj.editabled === false) return true;

            if (typeof obj.disable === 'object' && obj.disable !== null) {
                if (obj.disable.type === 'self') {
                    if (obj.disable.self) {
                        var selfType = obj.disable.self.type;
                        var selfValue = this.state.formData[item.dataField];
                        var values = obj.disable.self.values;
                        var value = obj.disable.self.value;

                        if (selfType === 'diff') {
                            return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                        } else {
                            return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                        }
                    }
                } else return AntCondition.isDisable(this.state.formData, obj);
            }

            if (typeof obj.editable === 'object' && obj.editable !== null) {
                if (obj.editable.type === 'self') {
                    if (obj.editable.self) {
                        var selfType = obj.editable.self.type;
                        var selfValue = this.state.formData[item.dataField];
                        var values = obj.editable.self.values;
                        var value = obj.editable.self.value;

                        if (selfType === 'diff') {
                            return values instanceof Array ? values.indexOf(selfValue) >= 0 : selfValue === value;
                        } else {
                            return values instanceof Array ? values.indexOf(selfValue) <= -1 : selfValue !== value;
                        }
                    }
                } else return !AntCondition.isEditable(this.state.formData, obj);
            }
        }

        return false;
    }

    isVisibleField(item) {
        if (!this.state || !this.state.formData || Object.keys(this.state.formData).length <= 0) return false;

        var visible = AntCondition.isVisible(this.state.formData, item);
        if (visible === false) return false;

        if (item.itemType === 'group') {
            var gLabel = AntCondition.getValue(this.state.formData, item.label);
            gLabel = AntLocalization.translateText(gLabel);

            visible = false;
            if (this.state.rawItems instanceof Array) {
                var childVisibleQty = this.state.rawItems
                    .filter((e) => {
                        if (e.item_type === 'group') return false;
                        var eName = e.groupName;
                        var eLabel = AntCondition.getValue(this.state.formData, e.groupLabel);
                        eLabel = AntLocalization.translateText(eLabel);
                        return item.name ? eName === item.name : eLabel === gLabel;
                    })
                    .map((e) => {
                        return this.isVisibleField(e);
                    })
                    .filter((e) => Boolean(e)).length;
                visible = childVisibleQty > 0;
            }
            return visible;
        }

        var rawItem;
        if (this.state.rawItems instanceof Array) rawItem = this.state.rawItems.find((e) => e.dataField === item.dataField);
        if (!rawItem) rawItem = item;

        if (visible && rawItem.visibleDepends instanceof Array) {
            for (let i = 0; i < rawItem.visibleDepends.length; i++) {
                const d = rawItem.visibleDepends[i];
                if (visible && d.dataField) {
                    var secondItem = this.state.rawItems.find((e) => d.dataField === e.dataField);
                    if (secondItem) {
                        if (d.visible !== undefined) {
                            var v2 = this.isVisibleField(secondItem) === d.visible;
                            visible = visible && v2;
                        }
                        if (d.editable !== undefined) {
                            var v2 = !this.isDisableField(secondItem) === d.editable;
                            visible = visible && v2;
                        }
                    }
                }
            }
        }

        if (visible) {
            var cnfItem = this.config.getCnfField(rawItem.cnfField ? rawItem.cnfField : rawItem.dataField);
            if (cnfItem && cnfItem.visibleDepends instanceof Array) {
                for (let i = 0; i < cnfItem.visibleDepends.length; i++) {
                    const d = cnfItem.visibleDepends[i];
                    if (visible && d.dataField) {
                        var secondItem = this.state.rawItems.find((e) => d.dataField === e.dataField);
                        if (secondItem) {
                            if (d.visible !== undefined) {
                                var v2 = this.isVisibleField(secondItem) === d.visible;
                                visible = visible && v2;
                            }
                            if (d.editable !== undefined) {
                                var v2 = !this.isDisableField(secondItem) === d.editable;
                                visible = visible && v2;
                            }
                        }
                    }
                }
            }
        }

        if (visible) {
            var cnfItem = this.config.getCnfField(rawItem.cnfField ? rawItem.cnfField : rawItem.dataField);
            if (cnfItem) {
                visible = AntCondition.isVisible(this.state.formData, cnfItem);
                if (visible && cnfItem.visibleOnMain) {
                    let vObj = cnfItem.visibleOnMain;
                    if (cnfItem.visibleOnMain instanceof Array) {
                        vObj = cnfItem.visibleOnMain.find(
                            (v) =>
                                v.table === this.state.tableName ||
                                (v.table instanceof Array && v.table.includes(this.state.tableName)) ||
                                (v.tables instanceof Array && v.tables.includes(this.state.tableName))
                        );

                        if (vObj) vObj = vObj.value;
                    }
                    if (vObj)
                        visible = AntCondition.isVisible(this.state.formData, {
                            visible: vObj
                        });
                }
                if (visible && cnfItem.visibleSelf)
                    visible = AntCondition.isVisible(this.state.formData, {
                        visible: cnfItem.visibleSelf
                    });
            }
        }

        return visible;
    }

    isRenderField(item) {
        if (!this.state || !this.state.formData) return true;

        var render = null;

        if (this.state.rawItems instanceof Array) {
            var obj = this.state.rawItems.find((e) => e.dataField === item.dataField);
            if (obj) render = AntCondition.isRender(this.state.formData, obj);
        }
        if (render === false) return false;

        var obj = this.config.getCnfField(item.cnfField ? item.cnfField : item.dataField);
        if (obj) render = AntCondition.isRender(this.state.formData, obj);

        if (render === false) return false;

        return true;
    }

    getDefaultFieldValue(item) {
        if (this.state.rawItems instanceof Array) {
            var rawItem = this.state.rawItems.find((e) => e.dataField === item.dataField);
            if (rawItem) {
                var value = AntCondition.getDefault(this.state.formData, rawItem);
                if (value !== undefined && value !== null) return value;
            }
        }

        var cnfItem = this.config.getCnfField(item.cnfField ? item.cnfField : item.dataField);
        if (cnfItem) {
            var value = AntCondition.getDefault(this.state.formData, cnfItem);
            if (value !== undefined && value !== null) return value;
        }
        return undefined;
    }

    getChangedFields() {
        var obj = {};
        var formData = this.state.formData;
        var oldData = this.state.oldData;
        var edit = this.state.formData.edit;
        var actions = this.state.formData.actions;

        var formLookups =
            this.state && this.state.formLookups instanceof Array && this.state.formLookups.length > 0
                ? this.state.formLookups
                : this.state.formData && this.state.formData.lookups instanceof Array
                ? this.state.formData.lookups
                : [];

        var that = this;

        Object.keys(formData).forEach(function (fieldName) {
            if (that.state.items instanceof Array) {
                var item = that.state.items.find((e) => e.dataField === fieldName);
                if (item && item.viewOnly) return;
            }

            var fObj = formData[fieldName];
            if (
                fObj !== edit &&
                fObj !== actions &&
                fObj !== formLookups &&
                fObj !== oldData &&
                fObj !== oldData[fieldName] &&
                JSON.stringify(fObj) !== JSON.stringify(oldData[fieldName])
            )
                obj[fieldName] = fObj;
        });

        Object.keys(obj).forEach((k) => {
            if (k === 'actions' || k === 'lookups') obj[k] = undefined;
            if (typeof obj[k] === 'object' && obj[k] !== null && obj[k] instanceof Array === false) obj[k] = undefined;
        });

        if (obj && this.props.postFields instanceof Array)
            Object.keys(obj).forEach((k) => {
                var found = this.props.postFields.find((field) => {
                    if (typeof field === 'object') return field.field === k;
                    else return field === k;
                });

                if (!found) obj[k] = undefined;
            });

        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });

        return { ...obj };
    }

    initItems() {
        var that = this;

        this.state.items = [];

        this.state.rawItems.forEach((rItem) => {
            var item = JSON.parse(JSON.stringify(rItem));

            if (item.itemType !== 'button') item.template = 'renderItem';
            if (item.itemType === 'button') {
                item.buttonOptions = {
                    ...item.buttonOptions,
                    onClick: rItem.onClick,
                    text: AntLocalization.translateText(item.text)
                };
            }

            item.rItem = JSON.parse(JSON.stringify(rItem));
            item.name = item.name ? item.item : item.dataField;

            if (rItem.dataField || rItem.cnfField || rItem.cnfTable) {
                var tableName = rItem.cnfTable
                    ? rItem.cnfTable
                    : that.props.table
                    ? that.props.table
                    : that.props.API
                    ? that.props.API.entityName
                    : null;

                var strField = rItem.cnfField ? rItem.cnfField : rItem.dataField;
                item.fieldConfig = that.config.getCnfField(strField, tableName);

                // if (item.fieldConfig && item.fieldConfig.cnfTable) {
                //     tableName = item.fieldConfig.cnfTable;

                //     var strField = item.fieldConfig.cnfField ? item.fieldConfig.cnfField : item.dataField;
                //     item.fieldConfig = that.config.getCnfField(strField, tableName);
                // }
            }

            var rItem = item.rItem;
            var editorName = rItem.editorName;
            var editorType = rItem.editorType;

            item.editorConfig = null;

            if (editorName && (typeof editorName === 'object' || editorName instanceof Array)) {
                editorName = AntCondition.getValue(that.state.formData, editorName, item.dataField);
            }

            if (editorType && (typeof editorType === 'object' || editorType instanceof Array))
                editorType = AntCondition.getValue(that.state.formData, editorType);

            if (editorName) {
                item.editorConfig = that.config.getCnfEditor(editorName);

                if (item.editorConfig) {
                    editorName = item.editorConfig.name;
                    editorType = item.editorConfig.type;
                }
            }

            if (!editorType) {
                if (
                    (item.fieldConfig && item.fieldConfig.lookup && item.fieldConfig.lookup.values instanceof Array) ||
                    (item.options && item.options.values instanceof Array)
                )
                    editorType = 'antSelectBox';
            }

            if (!editorType && item.fieldConfig && item.fieldConfig.editorType) editorType = item.fieldConfig.editorType;
            if (!editorName && item.fieldConfig && item.fieldConfig.editorName) editorName = item.fieldConfig.editorName;

            item.editorType = editorType;
            item.editorName = editorName;

            if (item.label instanceof Array) {
                var txtLabel = AntCondition.getValue(that.state.formData, item.label);
                txtLabel = AntLocalization.translateText(txtLabel);
                item.label = { text: txtLabel };
            } else item.label = { text: AntLocalization.translateText(item.label) };

            if (item.options && item.options instanceof Array) {
                item.options = AntCondition.getValue(that.state.formData, item.options, item.dataField);
            }

            if (!item.options) item.options = {};
            if (item.underlined) item.options.stylingMode = 'underlined';

            var classes = [];
            if (item.bold) classes.push('ant-bold-editor');
            if (item.hideBorder || this.props.hideBorder) classes.push('ant-hide-border-editor');
            if (item.upperCase) classes.push('ant-upper-case-editor');
            if (item.lowerCase) classes.push('ant-lower-case-editor');
            if (item.alignment === 'right') classes.push('ant-align-right-editor');
            if (item.alignment === 'left') classes.push('ant-align-left-editor');
            if (item.alignment === 'center') classes.push('ant-align-center-editor');
            if (classes.length > 0) item.options.className = classes.join(' ');

            if (item.fieldConfig) {
                if (item.fieldConfig.label) {
                    if (!item.label) item.label = { text: AntLocalization.translateText(item.fieldConfig.label) };
                    else if (!item.label.text) item.label.text = AntLocalization.translateText(item.fieldConfig.label);
                }
                if (!item.placeholder) item.placeholder = item.fieldConfig.placeholder;
                if (!item.type) item.type = item.fieldConfig.type;
                if (!item.dataType) item.dataType = item.fieldConfig.dataType;
                if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = item.fieldConfig.decimalDigit;
            }

            if (item.dataField === 'code' && that.props.API && that.props.API.entityDisplay) {
                if (!item.label) item.label = { text: AntLocalization.translateText(that.props.API.entityDisplay) };
                else if (!item.label.text) item.label.text = AntLocalization.translateText(that.props.API.entityDisplay);
            }

            if (item.editorConfig) {
                if (item.editorConfig.label) {
                    if (!item.label) item.label = { text: AntLocalization.translateText(item.editorConfig.label) };
                    else if (!item.label.text) item.label.text = AntLocalization.translateText(item.editorConfig.label);
                }
                if (!item.placeholder) item.placeholder = item.editorConfig.placeholder;
                if (!item.type) item.type = item.editorConfig.type;
                if (!item.dataType) item.dataType = item.editorConfig.dataType;
                if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = item.editorConfig.decimalDigit;
                // if (!item.lookup) item.lookup = item.editorConfig.lookup;
            }

            // Sys_NumberDecimalDigit đã bỏ (số lẻ là giá trị dẫn xuất từ đồng tiền + quốc gia).
            // Dùng chung đường giải với các thành phần mới để màn hình khớp cách máy chủ làm tròn.
            if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = AntLocalization.getCurrencyDecimalDigit();
            if (item.decimalDigit === undefined || item.decimalDigit === null) item.decimalDigit = 2;

            if (item.label && item.showLabel !== undefined) item.label.visible = item.showLabel;

            if (item.editorType == 'checkBox' || item.dataType == 'bool') {
                if (that.props.labelLocation === 'right' || that.props.allCheckBoxLeft || item.checkBoxLeft) {
                    if (!item.label) item.label = {};

                    item.label.oldText = item.label && item.label.text ? AntLocalization.translateText(item.label.text) : null;
                    item.label.text = undefined;
                    item.label.visible = false;
                }
            }
            if (!item.placeholder)
                item.placeholder =
                    item.fieldConfig && item.fieldConfig.label
                        ? AntLocalization.translateText(item.fieldConfig.label)
                        : item.editorConfig && item.editorConfig.label
                        ? AntLocalization.translateText(item.editorConfig.label)
                        : '...';

            this.state.items.push(item);
        });

        this.state.items.forEach((item) => {
            item.render = this.isRenderField(item);
            item.visible = this.isVisibleField(item);
            var disabled = this.isDisableField(item);
            if (item.editorType === 'antFormLink') {
                item.readOnly = disabled;
                item.disabled = false;
            }
            // else if (item.itemType === 'button') {
            //     item.disabled = false;
            // }
            else item.disabled = disabled;

            item.canValidate = this.isValidatableField(item);

            if (!item.canValidate) item.validationRules = [];
            else {
                var newRules = [];

                var obj = this.config.getCnfField(item.dataField);

                if (item.clientRules !== null) {
                    if (obj && obj.clientRules && obj.clientRules instanceof Array) {
                        newRules = newRules.concat(
                            obj.clientRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                    if (item.clientRules instanceof Array) {
                        newRules = newRules.concat(
                            item.clientRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                }
                if (item.serverRules !== null) {
                    if (obj && obj.serverRules && obj.serverRules instanceof Array) {
                        newRules = newRules.concat(
                            obj.serverRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                    if (item.serverRules instanceof Array) {
                        newRules = newRules.concat(
                            item.serverRules.map((r) => {
                                return { ...r, validationCallback: undefined };
                            })
                        );
                    }
                }

                if (item.exValidationRules && item.exValidationRules instanceof Array) {
                    newRules = newRules.concat(
                        item.exValidationRules.map((r) => {
                            if (r.type === 'async') {
                                var fItem = this.props.items.find((i) => i.dataField === item.dataField);
                                if (fItem && fItem.exValidationRules instanceof Array) {
                                    var found = fItem.exValidationRules.find((i) => i.type === 'async' && i.message === r.message);
                                    if (found) return found;
                                }
                            }
                            return { ...r };
                        })
                    );
                }

                for (let j = 0; j < newRules.length; j++) {
                    var r = newRules[j];
                    r.customType = r.type;
                    r.customValue = r.value;

                    if (r.type == 'async' && !r.validationCallback) {
                        r.validationCallback = this.validateItem;
                        if (!r.message) r.message = 'Đã tồn tại';
                    }

                    if (r.type == 'unique' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = this.validateItem;
                        r.message = 'Đã tồn tại';
                    }

                    if (r.type == 'must-not-existed' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = this.validateItem;
                        r.message = 'Đã tồn tại';
                    }

                    if (r.type == 'must-existed' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = this.validateItem;
                        r.message = 'Không tồn tại';
                    }

                    if (r.type == 'greaterThan' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = this.validateItem;
                        r.message = `Phải > ${r.value}`;
                    }

                    if (r.type == 'lessThan' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = this.validateItem;
                        r.message = `Phải < ${r.value}`;
                    }

                    if (r.type == 'min' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = this.validateItem;
                        r.message = `Phải >= ${r.value}`;
                    }

                    if (r.type == 'max' && !r.validationCallback) {
                        r.type = 'async';
                        r.validationCallback = this.validateItem;
                        r.message = `Phải <= ${r.value}`;
                    }

                    if (r.type == 'required' && !r.message) r.message = 'Không được trống';

                    if (r.type == 'stringLength') {
                        if (!r.message) {
                            if (r.min === undefined && r.max !== undefined) r.message = `Tối đa ${r.max} ký tự`;
                            else if (r.max === undefined && r.min !== undefined) r.message = `Tối thiểu ${r.min} ký tự`;
                            else if (r.min !== undefined && r.max !== undefined) r.message = `Yêu cầu từ ${r.min} -> ${r.max} ký tự`;
                        }
                    }

                    if (r.type == 'numberOnly') {
                        r.type = 'pattern';
                        r.pattern = /^\d+$/;
                        r.message = 'Chỉ được nhập số';
                    }

                    if (r.type == 'textOnly') {
                        r.type = 'pattern';
                        r.pattern = /[a-zA-Z\s]$/;
                        r.message = 'Chỉ được nhập chữ';
                    }

                    if (r.type == 'email') {
                        r.type = 'pattern';
                        r.pattern = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
                        r.message = 'Không hợp lệ';
                    }

                    if (r.type == 'withoutSpace') {
                        r.type = 'pattern';
                        r.pattern = /^[^\s]+$/;
                        r.message = 'Không được nhập khoảng trắng';
                    }

                    if (r.type == 'withoutSpecialKeys') {
                        r.type = 'pattern';
                        r.message = 'Chứa ký tự đặc biệt';
                    }
                    if (r.type == 'pattern' && !r.message) {
                        r.type = 'pattern';
                        r.message = 'Không hợp lệ';
                    }

                    // if (item.label && item.label.text)
                    //   r.message = `${item.label.text} ${String(r.message).toLowerCase()}`;
                }

                if (item.byPassRequired || this.props.byPassRequired) newRules = newRules.filter((r) => r.type !== 'required');

                newRules.sort((a, b) => (a.index > b.index ? 1 : b.index > a.index ? -1 : 0));

                item.validationRules = newRules;
            }
        });
    }

    async validate() {
        var that = this;
        return new Promise(async (resolve) => {
            if (that.group && ValidationEngine.getGroupConfig(that.group)) {
                var res = that.group.validate();
                if (res.status === 'pending') {
                    res.complete.then((r) => {
                        resolve(r.status === 'valid');
                    });
                } else {
                    resolve(res.isValid);
                }
            } else resolve(true);
        });
    }

    async validateItem(args) {
        var fieldName = args.validator.option().dataField;
        if (!fieldName) return true;
        var item = this.state.items.find((i) => i.dataField == fieldName);
        if (item && item.disabled) return true;

        if (args.rule) {
            if (args.rule.customType === 'greaterThan' && typeof args.rule.customValue === 'number') {
                return (
                    isNaN(args.value) ||
                    args.value === undefined ||
                    args.value === null ||
                    (typeof args.value === 'number' && parseFloat(args.value) > parseFloat(args.rule.customValue))
                );
            }

            if (args.rule.customType === 'lessThan' && typeof args.rule.customValue === 'number') {
                return (
                    isNaN(args.value) ||
                    args.value === undefined ||
                    args.value === null ||
                    (typeof args.value === 'number' && parseFloat(args.value) < parseFloat(args.rule.customValue))
                );
            }

            if (args.rule.customType === 'min' && typeof args.rule.customValue === 'number') {
                return (
                    isNaN(args.value) ||
                    args.value === undefined ||
                    args.value === null ||
                    (typeof args.value === 'number' && parseFloat(args.value) >= parseFloat(args.rule.customValue))
                );
            }

            if (args.rule.customType === 'max' && typeof args.rule.customValue === 'number') {
                return (
                    isNaN(args.value) ||
                    args.value === undefined ||
                    args.value === null ||
                    (typeof args.value === 'number' && parseFloat(args.value) <= parseFloat(args.rule.customValue))
                );
            }
        }

        var obj = {
            id: this.state && this.state.formData ? this.state.formData.id : undefined
        };
        obj['check_' + fieldName] = true;
        obj['new_' + fieldName] = args.value;
        if (this.state.oldData) {
            obj['old_' + fieldName] = this.state.oldData[fieldName];
            if (obj['old_' + fieldName] === obj['new_' + fieldName]) return true;
        }

        var result = await this.API.postValidation(obj);

        if (this.state.actionStatus !== 'Saving') {
            if (result && result.data && typeof result.data.default === 'object') {
                var that = this;

                var data = result.data.default;
                var keys = Object.keys(data);
                for (let i = 0; i < keys.length; i++) {
                    const k = keys[i];
                    await that.setField(k, data[k], false);
                }
            }
        }
        return result && result.data && result.data.isValid;
    }

    async resetUI(withoutUpdate) {
        if (!withoutUpdate) this.beginUpdate();
        await this.resetDefaultValue();
        await this.resetVisibility();
        await this.resetDisabled();
        await this.resetColSpan();
        if (!withoutUpdate) this.endUpdate();
    }

    resetVisibility() {
        let gr = [];
        let changed = false;
        if (this.state.rawItems instanceof Array) {
            for (let i = 0; i < this.state.rawItems.length; i++) {
                const item = this.state.rawItems[i];
                let visible = this.isVisibleField(item);
                if (this.form) {
                    let grouplabel = item.groupLabel;
                    if (item.groupLabel) {
                        if (item.groupLabel instanceof Array) {
                            grouplabel = AntCondition.getValue(this.state.formData, item.groupLabel);
                            grouplabel = AntLocalization.translateText(grouplabel);
                        }
                    }

                    let itemName = item.name ? item.name : item.dataField;
                    let itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;
                    if (!itemPath) itemPath = item && grouplabel ? grouplabel + '.' + itemName : null;
                    if (!itemPath) itemPath = itemName;
                    if (itemPath) {
                        let formItem = this.form.itemOption(itemPath);
                        if (formItem) {
                            let currentVisible = formItem.visible;
                            if (currentVisible !== visible) {
                                changed = true;
                                this.form.itemOption(itemPath, 'visible', visible);
                                if (this.props.onVisibleFieldChanged) this.props.onVisibleFieldChanged(itemName, visible);
                            }
                        }
                    }
                }
            }
        }

        return changed;
    }

    getFirstFocusableField(afterField) {
        if (this.state.rawItems instanceof Array) {
            var foundAfterField = false;

            for (let i = 0; i < this.state.rawItems.length; i++) {
                const item = this.state.rawItems[i];
                if (item.dataField === afterField) {
                    foundAfterField = true;
                    continue;
                }
                if (!afterField || foundAfterField) {
                    var disabled = this.isDisableField(item);
                    var visible = this.isVisibleField(item);
                    if (visible && !disabled && item.dataField !== 'code' && item.dataField !== 'id') return item.dataField;
                }
            }
        }
    }

    isFocusableField(fieldName) {
        if (this.state.rawItems instanceof Array) {
            for (let i = 0; i < this.state.rawItems.length; i++) {
                const item = this.state.rawItems[i];
                if (item.dataField === fieldName) {
                    var disabled = this.isDisableField(item);
                    var visible = this.isVisibleField(item);

                    return visible && !disabled && item.dataField !== 'id';
                }
            }
        }

        return false;
    }

    resetDisabled() {
        var changed = false;
        if (this.state.rawItems instanceof Array) {
            for (let i = 0; i < this.state.rawItems.length; i++) {
                const item = this.state.rawItems[i];
                var disabled = this.isDisableField(item);

                if (this.form) {
                    let grouplabel = item.groupLabel;
                    if (item.groupLabel) {
                        if (item.groupLabel instanceof Array) {
                            grouplabel = AntCondition.getValue(this.state.formData, item.groupLabel);
                            grouplabel = AntLocalization.translateText(grouplabel);
                        }
                    }

                    var itemName = item.name ? item.name : item.dataField;
                    var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;
                    if (!itemPath) itemPath = item && grouplabel ? grouplabel + '.' + itemName : null;
                    if (!itemPath) itemPath = itemName;

                    var formItem = this.form.itemOption(itemPath);
                    if (formItem) {
                        if (item.editorType === 'antFormLink') {
                            var currentReadOnly = formItem.readOnly;
                            if (currentReadOnly !== disabled) {
                                changed = true;
                                this.form.itemOption(itemPath, 'readOnly', disabled);
                                if (this.props.onDisableFieldChanged) this.props.onDisableFieldChanged(itemName, disabled);
                            }
                        } else {
                            var currentDisabled = formItem.disabled;
                            if (currentDisabled !== disabled) {
                                changed = true;
                                this.form.itemOption(itemPath, 'disabled', disabled);
                                if (this.props.onDisableFieldChanged) this.props.onDisableFieldChanged(itemName, disabled);
                            }
                        }
                    }
                }
            }
        }
        return changed;
    }

    resetColSpan() {
        var changed = false;
        if (this.state.rawItems instanceof Array) {
            for (let i = 0; i < this.state.rawItems.length; i++) {
                const item = this.state.rawItems[i];

                var colSpan = AntCondition.getValue(this.state.formData, item.colSpan);
                if (colSpan === undefined) colSpan = item.colSpanDefault;

                if (this.form) {
                    let grouplabel = item.groupLabel;
                    if (item.groupLabel) {
                        if (item.groupLabel instanceof Array) {
                            grouplabel = AntCondition.getValue(this.state.formData, item.groupLabel);
                            grouplabel = AntLocalization.translateText(grouplabel);
                        }
                    }

                    var itemName = item.name ? item.name : item.dataField;
                    var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;
                    if (!itemPath) itemPath = item && grouplabel ? grouplabel + '.' + itemName : null;
                    if (!itemPath) itemPath = itemName;

                    if (itemPath) {
                        var formItem = this.form.itemOption(itemPath);
                        if (formItem) {
                            var currentColSpan = formItem.colSpan;
                            if (currentColSpan !== colSpan) {
                                changed = true;
                                this.form.itemOption(itemPath, 'colSpan', colSpan);
                            }
                        }
                    }
                }
            }
        }
        return changed;
    }

    initDefaultValues() {
        var obj = {};

        if (this.state.rawItems instanceof Array) {
            for (let i = 0; i < this.state.rawItems.length; i++) {
                const item = this.state.rawItems[i];
                var defaultValue = this.getDefaultFieldValue(item);

                if (defaultValue !== undefined) {
                    if (typeof defaultValue === 'object' && defaultValue !== null && defaultValue.value !== undefined) {
                        obj[item.dataField] = defaultValue.value;
                        if (String(item.dataField).endsWith('_code')) {
                            var displayField = String(item.dataField).replace('_code', '_name');
                            obj[displayField] = defaultValue.display;
                        }
                    } else obj[item.dataField] = defaultValue;
                }
            }
        }
        return obj;
    }

    resetDefaultValue() {
        var changed = false;
        if (this.state.formData) {
            if (this.state.rawItems instanceof Array) {
                for (let i = 0; i < this.state.rawItems.length; i++) {
                    const item = this.state.rawItems[i];
                    if (this.state.formData[item.dataField] === undefined) {
                        var defaultValue = this.getDefaultFieldValue(item);
                        if (defaultValue !== undefined) {
                            if (typeof defaultValue === 'object' && defaultValue !== null && defaultValue.value !== undefined) {
                                this.state.formData[item.dataField] = defaultValue.value;

                                if (String(item.dataField).endsWith('_code')) {
                                    var displayField = String(item.dataField).replace('_code', '_name');
                                    this.state.formData[displayField] = defaultValue.display;
                                }
                            } else this.state.formData[item.dataField] = defaultValue;

                            if (this.form) {
                                var itemName = item.name ? item.name : item.dataField;
                                var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;

                                var grouplabel = item.groupLabel;

                                if (item.groupLabel) {
                                    if (item.groupLabel instanceof Array) {
                                        grouplabel = AntCondition.getValue(this.state.formData, item.groupLabel);
                                        grouplabel = AntLocalization.translateText(grouplabel);
                                    }
                                }

                                if (!itemPath) itemPath = item && item.groupLabel ? grouplabel + '.' + itemName : null;
                                if (!itemPath) itemPath = itemName;

                                this.form.itemOption(itemPath, 'value', defaultValue);
                            }
                            if (this.props.onDefaultValueChanged) this.props.onDefaultValueChanged(itemName, defaultValue);
                        }
                    }
                }
            }
        }
        return changed;
    }

    renderItem(args) {
        var item = this.state.items.filter((i) =>
            args.name ? i.name === args.name && i.dataField === args.dataField : i.dataField === args.dataField
        )[0];

        var fieldConfig = item.fieldConfig;

        var that = this;

        if (!item.fieldConfig) {
            if (item.dataField || item.cnfField) {
                var tableName = item.cnfTable
                    ? item.cnfTable
                    : this.props.table
                    ? this.props.table
                    : this.props.API
                    ? this.props.API.entityName
                    : null;

                var strField = item.cnfField ? item.cnfField : item.dataField;
                item.fieldConfig = this.config.getCnfField(strField, tableName);

                // if (item.fieldConfig && item.fieldConfig.cnfTable) {
                //     var tableName = item.fieldConfig.cnfTable;

                //     var strField = item.fieldConfig.cnfField ? item.fieldConfig.cnfField : item.field;
                //     item.fieldConfig = this.config.getCnfField(strField, tableName);
                // }
            }
        }

        var formData = this.state && this.state.formData ? this.state.formData : null;
        var oldData = this.state && this.state.oldData ? this.state.oldData : null;
        var formLookups =
            this.state && this.state.formLookups instanceof Array && this.state.formLookups.length > 0
                ? this.state.formLookups
                : this.state.formData && this.state.formData.lookups instanceof Array
                ? this.state.formData.lookups
                : [];

        var rItem = item.rItem;
        var editorName = rItem.editorName;
        var editorType = rItem.editorType;

        item.editorConfig = null;

        if (editorName && (typeof editorName === 'object' || editorName instanceof Array))
            editorName = AntCondition.getValue(this.state.formData, editorName);

        if (editorType && (typeof editorType === 'object' || editorType instanceof Array))
            editorType = AntCondition.getValue(this.state.formData, editorType);

        if (editorName) {
            item.editorConfig = this.config.getCnfEditor(editorName);

            if (item.editorConfig) {
                editorName = item.editorConfig.name;
                editorType = item.editorConfig.type;
            }
        }

        if (!editorType) {
            if (
                (item.fieldConfig && item.fieldConfig.lookup && item.fieldConfig.lookup.values instanceof Array) ||
                (item.options && item.options.values instanceof Array)
            )
                editorType = 'antSelectBox';
        }

        item.editorType = editorType;
        item.editorName = editorName;

        if (rItem.label) {
            if (rItem.label instanceof Array) {
                var txtLabel = AntCondition.getValue(this.state.formData, rItem.label);
                txtLabel = AntLocalization.translateText(txtLabel);

                if (item.label) item.label.text = txtLabel;
                else item.label = { text: txtLabel };
            }
        }

        var editorConfig = item.editorConfig;

        if (args.editorType == 'textArea') {
            return (
                <TextArea
                    height={83}
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </TextArea>
            );
        }

        var that = this;

        if (args.editorType == 'checkBox' || item.dataType == 'bool' || String(item.dataField).startsWith('is_')) {
            var obj = {};
            if (that.props.labelLocation === 'right' || that.props.allCheckBoxLeft || item.checkBoxLeft) {
                obj.text = item.label && item.label.oldText ? AntLocalization.translateText(item.label.oldText) : '';
                obj.width = '100%';
            }
            return (
                <CheckBox
                    {...item.options}
                    {...obj}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    defaultValue={formData ? formData[item.dataField] === 1 : false}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value ? 1 : 0
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </CheckBox>
            );
        }

        if (item.dataType === 'month' || args.editorType == 'antMonthBox') {
            var showClearButton = !item.disabled && (item.showClearButton !== undefined ? item.showClearButton : true);
            var showDropDownButton = !item.disabled && (item.showDropDownButton !== undefined ? item.showDropDownButton : true);

            return (
                <AntMonthBox
                    placeholder={'...'}
                    showClearButton={showClearButton}
                    showDropDownButton={showDropDownButton}
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    disabled={item.disabled}
                    focusStateEnabled={!Boolean(item.disabled)}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </AntMonthBox>
            );
        }

        if (item.dataType === 'year' || args.editorType == 'antYearBox') {
            var showClearButton = !item.disabled && (item.showClearButton !== undefined ? item.showClearButton : true);
            var showDropDownButton = !item.disabled && (item.showDropDownButton !== undefined ? item.showDropDownButton : true);

            return (
                <AntYearBox
                    placeholder={'...'}
                    showClearButton={showClearButton}
                    showDropDownButton={showDropDownButton}
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    disabled={item.disabled}
                    focusStateEnabled={!Boolean(item.disabled)}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </AntYearBox>
            );
        }

        if (String(item.dataField).endsWith('adm1_code')) {
            return (
                <AntSelectBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    API={this.props.API}
                    session={this.props.session}
                    isRemote={false}
                    useCustomStore={true}
                    defaultValue={formData ? formData[item.dataField] : null}
                    showClearButton={!item.disabled}
                    options={{
                        ...item.options,
                        dataSource: this.AddressData.getProvinces(),
                        valueExpr: 'code',
                        displayExpr: 'name'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    onValueChanged={(e) => {
                        var districtField = String(item.dataField).replace('adm1_code', 'adm2_code');
                        var wardField = String(item.dataField).replace('adm1_code', 'adm3_code');

                        that.onFieldDataChanged({
                            [item.dataField]: e.value,
                            [districtField]: null,
                            [wardField]: null
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }
        if (String(item.dataField).endsWith('adm2_code')) {
            var provinceField = String(item.dataField).replace('adm2_code', 'adm1_code');
            var adm1_code = formData ? formData[provinceField] : null;

            return (
                <AntSelectBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    API={this.props.API}
                    session={this.props.session}
                    isRemote={false}
                    useCustomStore={true}
                    defaultValue={formData ? formData[item.dataField] : null}
                    showClearButton={!item.disabled}
                    options={{
                        ...item.options,
                        dataSource: this.AddressData.getDistricts(adm1_code),
                        valueExpr: 'code',
                        displayExpr: 'name'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    onValueChanged={(e) => {
                        var wardField = String(item.dataField).replace('adm2_code', 'adm3_code');

                        that.onFieldDataChanged({
                            [item.dataField]: e.value,
                            [wardField]: null
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }
        if (String(item.dataField).endsWith('adm3_code')) {
            var districtField = String(item.dataField).replace('adm3_code', 'adm2_code');
            var adm2_code = formData ? formData[districtField] : null;

            return (
                <AntSelectBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    API={this.props.API}
                    session={this.props.session}
                    isRemote={false}
                    useCustomStore={true}
                    defaultValue={formData ? formData[item.dataField] : null}
                    showClearButton={!item.disabled}
                    options={{
                        ...item.options,
                        dataSource: this.AddressData.getWards(adm2_code),
                        valueExpr: 'code',
                        displayExpr: 'name'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }

        if (args.editorType == 'antFilterBuilder') {
            var tableName =
                item.options && item.options.table
                    ? item.options.table
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                    ? editorConfig.lookup.table
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                    ? fieldConfig.lookup.table
                    : null;

            var columns =
                item.options && item.options.columns
                    ? item.options.columns
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.columns
                    ? editorConfig.lookup.columns
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.columns
                    ? fieldConfig.lookup.columns
                    : null;

            var height =
                item.options && item.options.height !== undefined
                    ? item.options.height
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                    ? editorConfig.lookup.height
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                    ? fieldConfig.lookup.height
                    : null;

            var width =
                item.options && item.options.width !== undefined
                    ? item.options.width
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                    ? editorConfig.lookup.width
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                    ? fieldConfig.lookup.width
                    : undefined;

            var actionItems =
                item.options && item.options.actionItems instanceof Array
                    ? item.options.actionItems
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.actionItems instanceof Array
                    ? editorConfig.lookup.actionItems
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.actionItems instanceof Array
                    ? fieldConfig.lookup.actionItems
                    : undefined;

            return (
                <AntFilterBuilder
                    formRef={this.form}
                    dataField={item.dataField}
                    API={this.props.API}
                    name={this.state.tableName + '_' + item.name}
                    session={this.props.session}
                    value={formData ? formData[item.dataField] : null}
                    editorOptions={{
                        stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                        className: item.options && item.options.className ? item.options.className : undefined
                    }}
                    builderOptions={{
                        ...item.options,
                        table: tableName,
                        columns: columns
                    }}
                    height={height}
                    width={width}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                />
            );
        }

        if (args.editorType == 'dxSelectBox') {
            // dần bỏ

            var url =
                item.options && item.options.url
                    ? item.options.url
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                    ? editorConfig.lookup.url
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                    ? fieldConfig.lookup.url
                    : null;

            var isRemote =
                item.options && item.options.isRemote !== undefined
                    ? item.options.isRemote
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                    ? editorConfig.lookup.isRemote
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                    ? fieldConfig.lookup.isRemote
                    : Boolean(url);

            var searchConditions =
                item.options && item.options.searchConditions !== undefined
                    ? item.options.searchConditions
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                    ? editorConfig.lookup.searchConditions
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                    ? fieldConfig.lookup.searchConditions
                    : null;

            var lookupClientValues =
                item.options && item.options.values !== undefined
                    ? item.options.values
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                    ? editorConfig.lookup.values
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                    ? fieldConfig.lookup.values
                    : null;

            lookupClientValues =
                lookupClientValues instanceof Array && lookupClientValues.length > 0
                    ? lookupClientValues.map((o) => {
                          if (typeof o === 'string') return { code: o };
                          return o;
                      })
                    : typeof lookupClientValues === 'object' && lookupClientValues !== null
                    ? [lookupClientValues]
                    : typeof lookupClientValues === 'string' && lookupClientValues !== null
                    ? [{ code: lookupClientValues }]
                    : [];

            lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

            if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                if (item.options && item.options.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = item.options.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
                if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
            }

            var lookupServerName =
                item.options && item.options.lookupServerName !== undefined
                    ? item.options.lookupServerName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                    ? editorConfig.lookup.serverName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                    ? fieldConfig.lookup.serverName
                    : item.dataField;

            var lookupClientName =
                item.options && item.options.lookupClientName !== undefined
                    ? item.options.lookupClientName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                    ? editorConfig.lookup.clientName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                    ? fieldConfig.lookup.clientName
                    : item.dataField;

            var allowNew =
                item.options && item.options.allowNew !== undefined
                    ? item.options.allowNew
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                    ? editorConfig.lookup.allowNew
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                    ? fieldConfig.lookup.allowNew
                    : false;

            var dataSource = [];

            if (!isRemote) {
                if (lookupClientValues) dataSource = lookupClientValues;

                if (oldData && oldData.lookups instanceof Array && lookupServerName) {
                    var found = oldData.lookups.find((l) => l.name === lookupServerName);

                    if (found && found.values instanceof Array) {
                        found = JSON.parse(JSON.stringify(found));
                        for (let i = 0; i < found.values.length; i++) {
                            var newValue = found.values[i];
                            if (newValue.code) {
                                var oldValue = dataSource.find((d) => d.code === newValue.code);
                                if (oldValue) {
                                    Object.keys(newValue).forEach((k) => {
                                        if (oldValue[k] === undefined) oldValue[k] = newValue[k];
                                    });
                                } else dataSource.push(newValue);
                            } else dataSource.push(newValue);
                        }
                    }
                } else {
                    if (formData) dataSource.push(formData[item.dataField]);
                }
                if (searchConditions)
                    dataSource = dataSource.filter((value) =>
                        AntCondition.isValid(value, {
                            when: { ...searchConditions }
                        })
                    );
            }

            var showClearButton = !item.disabled && (item.showClearButton !== undefined ? item.showClearButton : true);
            var showDropDownButton = allowNew ? false : !item.disabled && (item.showDropDownButton !== undefined ? item.showDropDownButton : true);

            if (dataSource instanceof Array)
                dataSource = dataSource.map((d) => {
                    let vName = AntCondition.getValue(formData, d.name);
                    d.name = AntLocalization.translateText(vName);
                });

            return (
                <SelectBox
                    items={dataSource}
                    acceptCustomValue={allowNew}
                    placeholder={'...'}
                    showClearButton={showClearButton}
                    showDropDownButton={showDropDownButton}
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    noDataText={AntLocalization.translateText({
                        vi: 'Không có dữ liệu !',
                        en: 'Have no data !'
                    })}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </SelectBox>
            );
        }

        if (args.editorType == 'antSelectBox') {
            var dataSource = [];

            var url =
                item.options && item.options.url
                    ? item.options.url
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                    ? editorConfig.lookup.url
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                    ? fieldConfig.lookup.url
                    : null;

            var keyField =
                item.options && item.options.keyField
                    ? item.options.keyField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                    ? editorConfig.lookup.keyField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                    ? fieldConfig.lookup.keyField
                    : 'code';

            var valueField =
                item.options && item.options.valueField
                    ? item.options.valueField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                    ? editorConfig.lookup.valueField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                    ? fieldConfig.lookup.valueField
                    : 'code';

            var displayField =
                item.options && item.options.displayField
                    ? item.options.displayField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                    ? editorConfig.lookup.displayField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                    ? fieldConfig.lookup.displayField
                    : 'name';

            var formDisplayField =
                item.options && item.options.formDisplayField
                    ? item.options.formDisplayField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.formDisplayField
                    ? editorConfig.lookup.formDisplayField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.formDisplayField
                    ? fieldConfig.lookup.formDisplayField
                    : item.displayField;

            if (!formDisplayField) {
                var strField = String(item.dataField).replace('_code', '_name');
                if (strField !== item.dataField) formDisplayField = strField;
                else formDisplayField = item.dataField === 'code' ? 'name' : item.dataField;
            }

            var tableName =
                item.options && item.options.table
                    ? item.options.table
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                    ? editorConfig.lookup.table
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                    ? fieldConfig.lookup.table
                    : null;

            var height =
                item.options && item.options.height !== undefined
                    ? item.options.height
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                    ? editorConfig.lookup.height
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                    ? fieldConfig.lookup.height
                    : null;

            var width =
                item.options && item.options.width !== undefined
                    ? item.options.width
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                    ? editorConfig.lookup.width
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                    ? fieldConfig.lookup.width
                    : undefined;

            var mappings =
                item.options && item.options.mapping instanceof Array
                    ? item.options.mapping
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mapping instanceof Array
                    ? editorConfig.lookup.mapping
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mapping instanceof Array
                    ? fieldConfig.lookup.mapping
                    : [];

            var mappingWhen =
                item.options && item.options.mappingWhen instanceof Array
                    ? item.options.mappingWhen
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhen instanceof Array
                    ? editorConfig.lookup.mappingWhen
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhen instanceof Array
                    ? fieldConfig.lookup.mappingWhen
                    : null;

            var mappingWhenType =
                item.options && item.options.mappingWhenType instanceof Array
                    ? item.options.mappingWhenType
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhenType instanceof Array
                    ? editorConfig.lookup.mappingWhenType
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhenType instanceof Array
                    ? fieldConfig.lookup.mappingWhenType
                    : null;

            var parentFields = item.options && item.options.parentFields instanceof Array ? item.options.parentFields : undefined;

            var refreshOnOpened =
                parentFields !== undefined
                    ? true
                    : item.options && item.options.refreshOnOpened !== undefined
                    ? item.options.refreshOnOpened
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                    ? editorConfig.lookup.refreshOnOpened
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                    ? fieldConfig.lookup.refreshOnOpened
                    : undefined;

            var searchConditions =
                item.options && item.options.searchConditions !== undefined
                    ? item.options.searchConditions
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                    ? editorConfig.lookup.searchConditions
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                    ? fieldConfig.lookup.searchConditions
                    : null;

            var lookupClientValues =
                item.options && item.options.values !== undefined
                    ? item.options.values
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                    ? editorConfig.lookup.values
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                    ? fieldConfig.lookup.values
                    : null;

            lookupClientValues =
                lookupClientValues instanceof Array && lookupClientValues.length > 0
                    ? lookupClientValues.map((o) => {
                          if (typeof o === 'string') return { code: o };
                          return o;
                      })
                    : typeof lookupClientValues === 'object' && lookupClientValues !== null
                    ? [lookupClientValues]
                    : typeof lookupClientValues === 'string' && lookupClientValues !== null
                    ? [{ code: lookupClientValues }]
                    : [];

            lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

            if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                if (item.options && item.options.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = item.options.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
                if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
            }

            var lookupServerName =
                item.options && item.options.lookupServerName !== undefined
                    ? item.options.lookupServerName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                    ? editorConfig.lookup.serverName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                    ? fieldConfig.lookup.serverName
                    : item.dataField;

            var lookupClientName =
                item.options && item.options.lookupClientName !== undefined
                    ? item.options.lookupClientName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                    ? editorConfig.lookup.clientName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                    ? fieldConfig.lookup.clientName
                    : item.dataField;

            var isRemote =
                item.options && item.options.isRemote !== undefined
                    ? item.options.isRemote
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                    ? fieldConfig.lookup.isRemote
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                    ? editorConfig.lookup.isRemote
                    : Boolean(url);

            var remotePaging =
                item.options && item.options.remotePaging !== undefined
                    ? item.options.remotePaging
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.remotePaging !== undefined
                    ? fieldConfig.lookup.remotePaging
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.remotePaging !== undefined
                    ? editorConfig.lookup.remotePaging
                    : true;

            if (!isRemote) {
                if (lookupClientValues) dataSource = lookupClientValues;

                if (formLookups instanceof Array && lookupServerName) {
                    var found = formLookups.find((l) => l.name === lookupServerName);

                    if (found && found.values instanceof Array) {
                        found = JSON.parse(JSON.stringify(found));
                        var remoteDS = found.values;

                        for (let i = 0; i < remoteDS.length; i++) {
                            var remoteValue = remoteDS[i];
                            if (remoteValue) {
                                if (remoteValue.code) {
                                    var clientValue = dataSource.find((d) => d.code === remoteValue.code);
                                    if (clientValue) {
                                        Object.keys(remoteValue).forEach((k) => {
                                            if (clientValue[k] === undefined) clientValue[k] = remoteValue[k];
                                        });
                                    } else dataSource.push(remoteValue);
                                } else {
                                    dataSource.push(remoteValue);
                                }
                            }
                        }
                    }
                }
                if (searchConditions)
                    dataSource = dataSource.filter((value) =>
                        AntCondition.isValid(value, {
                            when: { ...searchConditions }
                        })
                    );
            }

            if (!height) height = 200;

            var isRequired = false;
            if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

            var allowNew =
                item.options && item.options.allowNew !== undefined
                    ? item.options.allowNew
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                    ? editorConfig.lookup.allowNew
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                    ? fieldConfig.lookup.allowNew
                    : false;

            var showClearButton =
                // !item.disabled &&
                item.options && item.options.showClearButton !== undefined
                    ? item.options.showClearButton
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                    ? editorConfig.lookup.showClearButton
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                    ? fieldConfig.lookup.showClearButton
                    : !isRequired;

            var showDropDownButton =
                allowNew || showClearButton
                    ? false
                    : !item.disabled &&
                      (item.options && item.options.showDropDownButton !== undefined
                          ? item.options.showDropDownButton
                          : editorConfig && editorConfig.lookup && editorConfig.lookup.showDropDownButton !== undefined
                          ? editorConfig.lookup.showDropDownButton
                          : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showDropDownButton !== undefined
                          ? fieldConfig.lookup.showDropDownButton
                          : true);

            var ordering =
                item.options && item.options.ordering !== undefined
                    ? item.options.ordering
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.ordering
                    ? editorConfig.lookup.ordering
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.ordering
                    ? fieldConfig.lookup.ordering
                    : null;

            return (
                <AntSelectBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    formDisplayField={formDisplayField}
                    API={this.props.API}
                    session={this.props.session}
                    url={url}
                    isRemote={isRemote}
                    remotePaging={remotePaging}
                    refreshOnOpened={refreshOnOpened}
                    lookupName={lookupServerName}
                    searchConditions={searchConditions}
                    defaultValue={formData ? formData[item.dataField] : null}
                    parentFields={parentFields}
                    isSearching={item.options && item.options.isSearching !== undefined ? item.options.isSearching : this.props.isSearching}
                    acceptCustomValue={allowNew}
                    showClearButton={showClearButton}
                    showDropDownButton={showDropDownButton}
                    height={height}
                    width={width}
                    ordering={ordering}
                    options={{
                        ...item.options,
                        table: tableName,
                        dataSource: dataSource,
                        keyExpr: keyField,
                        valueExpr: valueField,
                        displayExpr: displayField,
                        // placeholder: item.placeholder,
                        noDataText: 'Không có dữ liệu',
                        stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                        className: item.options && item.options.className ? item.options.className : undefined
                    }}
                    searchEnabled={Boolean(isRemote)}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    getQueryFields={() => {
                        return mappings.map((m) => m.from);
                    }}
                    onValueChanged={(e) => {
                        var oldData = that.state && that.state.oldData ? JSON.parse(JSON.stringify(that.state.oldData)) : {};
                        oldData[item.dataField] = e.value;
                        if (e.rowData && formDisplayField && formDisplayField !== item.dataField) preData[formDisplayField] = e.rowData[displayField];

                        var obj = { [item.dataField]: e.value };
                        if (formDisplayField && formDisplayField !== item.dataField) obj[formDisplayField] = preData[formDisplayField];

                        var isMapping = true;
                        if (mappingWhen && typeof mappingWhen === 'object') {
                            isMapping = AntCondition.isValid(oldData, {
                                when: mappingWhen,
                                whenType: mappingWhenType
                            });
                        }

                        if (isMapping) {
                            for (let i = 0; i < mappings.length; i++) {
                                const m = mappings[i];

                                if (m.when && typeof m.when === 'object') {
                                    var mValid = AntCondition.isValid(oldData, {
                                        when: m.when,
                                        whenType: m.whenType
                                    });
                                    if (!mValid) continue;
                                }

                                var sourceField = m.from;
                                var destField = m.to;
                                if (sourceField && destField) {
                                    if (
                                        e.rowData === null ||
                                        e.rowData === undefined ||
                                        e.rowData[sourceField] === null ||
                                        e.rowData[sourceField] === undefined
                                    ) {
                                        if (oldData[destField] !== null && oldData[destField] !== undefined) obj[destField] = null;
                                    } else {
                                        if (oldData[destField] !== e.rowData[sourceField]) obj[destField] = e.rowData[sourceField];
                                    }
                                }

                                var setField = m.set;
                                var fieldValue = m.value;
                                if (setField && fieldValue !== undefined) {
                                    obj[setField] = fieldValue;
                                }
                            }
                        }
                        var keys = Object.keys(obj);
                        for (let i = 0; i < keys.length; i++) {
                            const k = keys[i];
                            args.component.itemOption(k, 'value', obj[k]);
                        }

                        if (keys.length > 0) that.onFieldDataChanged(obj);
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }

        if (args.editorType == 'antTagBox') {
            var dataSource = [];

            var url =
                item.options && item.options.url
                    ? item.options.url
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                    ? editorConfig.lookup.url
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                    ? fieldConfig.lookup.url
                    : null;

            var keyField =
                item.options && item.options.keyField
                    ? item.options.keyField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                    ? editorConfig.lookup.keyField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                    ? fieldConfig.lookup.keyField
                    : 'code';

            var valueField =
                item.options && item.options.valueField
                    ? item.options.valueField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                    ? editorConfig.lookup.valueField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                    ? fieldConfig.lookup.valueField
                    : 'code';

            var displayField =
                item.options && item.options.displayField
                    ? item.options.displayField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                    ? editorConfig.lookup.displayField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                    ? fieldConfig.lookup.displayField
                    : 'name';

            var tableName =
                item.options && item.options.table
                    ? item.options.table
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                    ? editorConfig.lookup.table
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                    ? fieldConfig.lookup.table
                    : null;

            var height =
                item.options && item.options.height !== undefined
                    ? item.options.height
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                    ? editorConfig.lookup.height
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                    ? fieldConfig.lookup.height
                    : null;
            if (!height) height = 200;

            var width =
                item.options && item.options.width !== undefined
                    ? item.options.width
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                    ? editorConfig.lookup.width
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                    ? fieldConfig.lookup.width
                    : undefined;

            var parentFields = item.options && item.options.parentFields instanceof Array ? item.options.parentFields : undefined;

            var refreshOnOpened =
                parentFields !== undefined
                    ? true
                    : item.options && item.options.refreshOnOpened !== undefined
                    ? item.options.refreshOnOpened
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                    ? editorConfig.lookup.refreshOnOpened
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                    ? fieldConfig.lookup.refreshOnOpened
                    : undefined;

            var searchConditions =
                item.options && item.options.searchConditions !== undefined
                    ? item.options.searchConditions
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                    ? editorConfig.lookup.searchConditions
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                    ? fieldConfig.lookup.searchConditions
                    : null;

            var lookupClientValues =
                item.options && item.options.values !== undefined
                    ? item.options.values
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                    ? editorConfig.lookup.values
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                    ? fieldConfig.lookup.values
                    : null;

            lookupClientValues =
                lookupClientValues instanceof Array && lookupClientValues.length > 0
                    ? lookupClientValues.map((o) => {
                          if (typeof o === 'string') return { code: o };
                          return o;
                      })
                    : typeof lookupClientValues === 'object' && lookupClientValues !== null
                    ? [lookupClientValues]
                    : typeof lookupClientValues === 'string' && lookupClientValues !== null
                    ? [{ code: lookupClientValues }]
                    : [];

            lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

            if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                if (item.options && item.options.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = item.options.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
                if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
            }

            var lookupServerName =
                item.options && item.options.lookupServerName !== undefined
                    ? item.options.lookupServerName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                    ? editorConfig.lookup.serverName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                    ? fieldConfig.lookup.serverName
                    : item.dataField;

            var lookupClientName =
                item.options && item.options.lookupClientName !== undefined
                    ? item.options.lookupClientName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                    ? editorConfig.lookup.clientName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                    ? fieldConfig.lookup.clientName
                    : item.dataField;

            var isRemote =
                item.options && item.options.isRemote !== undefined
                    ? item.options.isRemote
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                    ? editorConfig.lookup.isRemote
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                    ? fieldConfig.lookup.isRemote
                    : Boolean(url);

            var remotePaging =
                item.options && item.options.remotePaging !== undefined
                    ? item.options.remotePaging
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.remotePaging !== undefined
                    ? editorConfig.lookup.remotePaging
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.remotePaging !== undefined
                    ? fieldConfig.lookup.remotePaging
                    : true;

            if (!isRemote) {
                if (
                    String(item.dataField).endsWith('category1') ||
                    String(item.dataField).endsWith('category2') ||
                    String(item.dataField).endsWith('category3')
                )
                    lookupClientValues = this.CategoryData.getCats();

                if (lookupClientValues) dataSource = lookupClientValues;

                if (formLookups instanceof Array && lookupServerName) {
                    var found = formLookups.find((l) => l.name === lookupServerName);

                    if (found && found.values instanceof Array) {
                        found = JSON.parse(JSON.stringify(found));
                        var remoteDS = found.values
                            .filter((v) => Boolean(v))
                            .map((v) => {
                                if (typeof v === 'object') return { ...v };
                                else return { code: v };
                            });

                        for (let i = 0; i < remoteDS.length; i++) {
                            var remoteValue = remoteDS[i];
                            if (remoteValue) {
                                if (remoteValue.code) {
                                    var clientValue = dataSource.find((d) => d.code === remoteValue.code);
                                    if (clientValue) {
                                        Object.keys(clientValue).forEach((k) => {
                                            if (remoteValue[k] === undefined) remoteValue[k] = clientValue[k];
                                        });
                                    } else dataSource.push(remoteValue);
                                } else {
                                    dataSource.push(remoteValue);
                                }
                            }
                        }
                    }
                }

                if (searchConditions)
                    dataSource = dataSource.filter((value) =>
                        AntCondition.isValid(value, {
                            when: { ...searchConditions }
                        })
                    );

                searchBar = false;
            }

            var isRequired = false;
            if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

            // var allowNew = false;
            var allowNew =
                item.options && item.options.allowNew !== undefined
                    ? item.options.allowNew
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                    ? editorConfig.lookup.allowNew
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                    ? fieldConfig.lookup.allowNew
                    : false;

            var showClearButton =
                // !item.disabled &&
                item.options && item.options.showClearButton !== undefined
                    ? item.options.showClearButton
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                    ? editorConfig.lookup.showClearButton
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                    ? fieldConfig.lookup.showClearButton
                    : !isRequired;

            var ordering =
                item.options && item.options.ordering !== undefined
                    ? item.options.ordering
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.ordering
                    ? editorConfig.lookup.ordering
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.ordering
                    ? fieldConfig.lookup.ordering
                    : null;

            if (formData && formData.edit && formData.edit.editable_fields && formData.edit.editable_fields instanceof Array) {
                var found = formData.edit.editable_fields.find((f) => typeof f === 'object' && f !== null && f.field === item.dataField);

                if (found && found.disableValues instanceof Array) {
                    dataSource.forEach((v) => {
                        if (found.disableValues.includes(v.code)) {
                            v.disabled = true;
                            showClearButton = false;
                        }
                    });
                }
            }

            return (
                <AntTagBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    formDisplayField={formDisplayField}
                    API={this.props.API}
                    session={this.props.session}
                    url={url}
                    isRemote={isRemote}
                    remotePaging={remotePaging}
                    refreshOnOpened={refreshOnOpened}
                    lookupName={lookupServerName}
                    searchConditions={searchConditions}
                    defaultValue={formData ? formData[item.dataField] : null}
                    parentFields={parentFields}
                    acceptCustomValue={allowNew}
                    showClearButton={showClearButton}
                    height={height}
                    width={width}
                    ordering={ordering}
                    options={{
                        ...item.options,
                        table: tableName,
                        dataSource: dataSource,
                        keyExpr: keyField,
                        valueExpr: valueField,
                        displayExpr: displayField,
                        // placeholder: item.placeholder,
                        noDataText: 'Không có dữ liệu',
                        stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                        className: item.options && item.options.className ? item.options.className : undefined
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    getQueryFields={() => {
                        return mappings.map((m) => m.from);
                    }}
                    onValueChanged={(e) => {
                        var value = e.value instanceof Array && e.value.length <= 0 ? null : e.value;

                        that.onFieldDataChanged({
                            [item.dataField]: value
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }

        if (args.editorType == 'antDropDownGrid') {
            var dataSource = [];

            var url =
                item.options && item.options.url
                    ? item.options.url
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                    ? editorConfig.lookup.url
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                    ? fieldConfig.lookup.url
                    : null;

            var keyField =
                item.options && item.options.keyField
                    ? item.options.keyField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                    ? editorConfig.lookup.keyField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                    ? fieldConfig.lookup.keyField
                    : null;

            var valueField =
                item.options && item.options.valueField
                    ? item.options.valueField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                    ? editorConfig.lookup.valueField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                    ? fieldConfig.lookup.valueField
                    : 'code';

            var displayField =
                item.options && item.options.displayField
                    ? item.options.displayField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                    ? editorConfig.lookup.displayField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                    ? fieldConfig.lookup.displayField
                    : 'name';

            var formDisplayField =
                item.options && item.options.formDisplayField
                    ? item.options.formDisplayField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.formDisplayField
                    ? editorConfig.lookup.formDisplayField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.formDisplayField
                    ? fieldConfig.lookup.formDisplayField
                    : item.displayField;

            if (!formDisplayField) {
                var strField = String(item.dataField).replace('_code', '_name');
                if (strField !== item.dataField) formDisplayField = strField;
                else formDisplayField = item.dataField === 'code' ? 'name' : item.dataField;
            }

            var tableName =
                item.options && item.options.table
                    ? item.options.table
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                    ? editorConfig.lookup.table
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                    ? fieldConfig.lookup.table
                    : null;

            var searchBar =
                item.options && item.options.searchBar !== undefined
                    ? item.options.searchBar
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.searchBar
                    ? editorConfig.lookup.searchBar
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchBar
                    ? fieldConfig.lookup.searchBar
                    : null;

            var columns =
                item.options && item.options.columns
                    ? item.options.columns
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.columns
                    ? editorConfig.lookup.columns
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.columns
                    ? fieldConfig.lookup.columns
                    : null;

            var height =
                item.options && item.options.height !== undefined
                    ? item.options.height
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                    ? editorConfig.lookup.height
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                    ? fieldConfig.lookup.height
                    : null;

            if (!height) {
                if (String(item.dataField).endsWith('code')) height = 250;
                else if (
                    (item.fieldConfig && item.fieldConfig.lookup && item.fieldConfig.lookup.values instanceof Array) ||
                    (item.options && item.options.values instanceof Array)
                )
                    height = 200;
                else height = 250;
            }

            var width =
                item.options && item.options.width !== undefined
                    ? item.options.width
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                    ? editorConfig.lookup.width
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                    ? fieldConfig.lookup.width
                    : undefined;

            var actionItems =
                item.options && item.options.actionItems instanceof Array
                    ? item.options.actionItems
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.actionItems instanceof Array
                    ? editorConfig.lookup.actionItems
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.actionItems instanceof Array
                    ? fieldConfig.lookup.actionItems
                    : undefined;

            var mappings =
                item.options && item.options.mapping instanceof Array
                    ? item.options.mapping
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mapping instanceof Array
                    ? editorConfig.lookup.mapping
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mapping instanceof Array
                    ? fieldConfig.lookup.mapping
                    : [];

            var mappingWhen =
                item.options && item.options.mappingWhen instanceof Array
                    ? item.options.mappingWhen
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhen instanceof Array
                    ? editorConfig.lookup.mappingWhen
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhen instanceof Array
                    ? fieldConfig.lookup.mappingWhen
                    : null;

            var mappingWhenType =
                item.options && item.options.mappingWhenType instanceof Array
                    ? item.options.mappingWhenType
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhenType instanceof Array
                    ? editorConfig.lookup.mappingWhenType
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhenType instanceof Array
                    ? fieldConfig.lookup.mappingWhenType
                    : null;

            var parentFields = item.options && item.options.parentFields instanceof Array ? item.options.parentFields : undefined;

            var refreshOnOpened =
                parentFields !== undefined
                    ? true
                    : item.options && item.options.refreshOnOpened !== undefined
                    ? item.options.refreshOnOpened
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                    ? editorConfig.lookup.refreshOnOpened
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                    ? fieldConfig.lookup.refreshOnOpened
                    : undefined;

            var searchConditions =
                item.options && item.options.searchConditions !== undefined
                    ? item.options.searchConditions
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                    ? editorConfig.lookup.searchConditions
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                    ? fieldConfig.lookup.searchConditions
                    : null;

            var lookupClientValues =
                item.options && item.options.values !== undefined
                    ? item.options.values
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                    ? editorConfig.lookup.values
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                    ? fieldConfig.lookup.values
                    : null;

            lookupClientValues =
                lookupClientValues instanceof Array && lookupClientValues.length > 0
                    ? lookupClientValues.map((o) => {
                          if (typeof o === 'string') return { code: o };
                          return o;
                      })
                    : typeof lookupClientValues === 'object' && lookupClientValues !== null
                    ? [lookupClientValues]
                    : typeof lookupClientValues === 'string' && lookupClientValues !== null
                    ? [{ code: lookupClientValues }]
                    : [];

            lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

            if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                if (item.options && item.options.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = item.options.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
                if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
            }
            var lookupServerName =
                item.options && item.options.lookupServerName !== undefined
                    ? item.options.lookupServerName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                    ? editorConfig.lookup.serverName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                    ? fieldConfig.lookup.serverName
                    : item.dataField;

            var lookupClientName =
                item.options && item.options.lookupClientName !== undefined
                    ? item.options.lookupClientName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                    ? editorConfig.lookup.clientName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                    ? fieldConfig.lookup.clientName
                    : item.dataField;

            var isRemote =
                item.options && item.options.isRemote !== undefined
                    ? item.options.isRemote
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                    ? editorConfig.lookup.isRemote
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                    ? fieldConfig.lookup.isRemote
                    : Boolean(url);

            var remotePaging =
                item.options && item.options.remotePaging !== undefined
                    ? item.options.remotePaging
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.remotePaging !== undefined
                    ? editorConfig.lookup.remotePaging
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.remotePaging !== undefined
                    ? fieldConfig.lookup.remotePaging
                    : true;

            if (!isRemote) {
                if (lookupClientValues) dataSource = lookupClientValues;

                if (formLookups instanceof Array && lookupServerName) {
                    var found = formLookups.find((l) => l.name === lookupServerName);

                    if (found && found.values instanceof Array) {
                        found = JSON.parse(JSON.stringify(found));
                        for (let i = 0; i < found.values.length; i++) {
                            var newValue = found.values[i];
                            if (newValue.code) {
                                var oldValue = dataSource.find((d) => d.code === newValue.code);
                                if (oldValue) {
                                    Object.keys(newValue).forEach((k) => {
                                        if (oldValue[k] === undefined) oldValue[k] = newValue[k];
                                    });
                                } else dataSource.push(newValue);
                            } else dataSource.push(newValue);
                        }
                    }
                }
                if (searchConditions)
                    dataSource = dataSource.filter((value) =>
                        AntCondition.isValid(value, {
                            when: { ...searchConditions }
                        })
                    );

                searchBar = false;
                if (!columns)
                    columns = [
                        {
                            dataField: 'name'
                        }
                    ];
            } else {
                if (!columns)
                    columns = [
                        {
                            dataField: item.dataField
                        }
                    ];
            }

            var isRequired = false;
            if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

            var allowNew =
                item.options && item.options.allowNew !== undefined
                    ? item.options.allowNew
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                    ? editorConfig.lookup.allowNew
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                    ? fieldConfig.lookup.allowNew
                    : false;

            var showClearButton =
                // !item.disabled &&
                item.options && item.options.showClearButton !== undefined
                    ? item.options.showClearButton
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                    ? editorConfig.lookup.showClearButton
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                    ? fieldConfig.lookup.showClearButton
                    : !isRequired;

            var showDropDownButton = showClearButton
                ? false
                : !item.disabled &&
                  (item.options && item.options.showDropDownButton !== undefined
                      ? item.options.showDropDownButton
                      : editorConfig && editorConfig.lookup && editorConfig.lookup.showDropDownButton !== undefined
                      ? editorConfig.lookup.showDropDownButton
                      : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showDropDownButton !== undefined
                      ? fieldConfig.lookup.showDropDownButton
                      : true);

            var showLookupButton =
                item.options && item.options.showLookupButton !== undefined
                    ? item.options.showLookupButton
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.showLookupButton !== undefined
                    ? editorConfig.lookup.showLookupButton
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showLookupButton !== undefined
                    ? fieldConfig.lookup.showLookupButton
                    : false;

            var showActions =
                item.options && item.options.showActions !== undefined
                    ? item.options.showActions
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.showActions !== undefined
                    ? editorConfig.lookup.showActions
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showActions !== undefined
                    ? fieldConfig.lookup.showActions
                    : true;

            var groupByField =
                item.options && item.options.groupByField !== undefined
                    ? item.options.groupByField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.groupByField
                    ? editorConfig.lookup.groupByField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.groupByField
                    ? fieldConfig.lookup.groupByField
                    : null;

            var ordering =
                item.options && item.options.ordering !== undefined
                    ? item.options.ordering
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.ordering
                    ? editorConfig.lookup.ordering
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.ordering
                    ? fieldConfig.lookup.ordering
                    : null;

            return (
                <AntDropDownGrid
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    formDisplayField={formDisplayField}
                    groupByField={groupByField}
                    API={this.props.API}
                    session={this.props.session}
                    url={url}
                    isRemote={isRemote}
                    remotePaging={remotePaging}
                    refreshOnOpened={refreshOnOpened}
                    lookupName={lookupServerName}
                    searchConditions={searchConditions}
                    value={formData ? formData[item.dataField] : null}
                    parentFields={parentFields}
                    isSearching={item.options && item.options.isSearching !== undefined ? item.options.isSearching : this.props.isSearching}
                    acceptCustomValue={allowNew}
                    showClearButton={showClearButton}
                    showDropDownButton={showDropDownButton}
                    showLookupButton={showLookupButton}
                    editorOptions={{
                        stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                        className: item.options && item.options.className ? item.options.className : undefined
                    }}
                    height={height}
                    width={width}
                    ordering={ordering}
                    gridOptions={{
                        ...item.options,
                        table: tableName,
                        dataSource: dataSource,
                        keyExpr: keyField,
                        valueExpr: valueField,
                        displayExpr: displayField,
                        columns: columns,
                        searchBar: searchBar,
                        showActions: showActions,
                        actionItems: actionItems,
                        placeholder: item.placeholder,
                        noDataText: 'Không có dữ liệu'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    getQueryFields={() => {
                        return mappings.map((m) => m.from);
                    }}
                    onValueChanged={(e) => {
                        var oldData = that.state && that.state.oldData ? JSON.parse(JSON.stringify(that.state.oldData)) : {};
                        oldData[item.dataField] = e.value;
                        if (e.rowData && formDisplayField && formDisplayField !== item.dataField) preData[formDisplayField] = e.rowData[displayField];

                        var obj = { [item.dataField]: e.value };
                        if (formDisplayField && formDisplayField !== item.dataField) obj[formDisplayField] = preData[formDisplayField];

                        var isMapping = true;
                        if (mappingWhen && typeof mappingWhen === 'object') {
                            isMapping = AntCondition.isValid(oldData, {
                                when: mappingWhen,
                                whenType: mappingWhenType
                            });
                        }

                        if (isMapping) {
                            for (let i = 0; i < mappings.length; i++) {
                                const m = mappings[i];

                                if (m.when && typeof m.when === 'object') {
                                    var mValid = AntCondition.isValid(oldData, {
                                        when: m.when,
                                        whenType: m.whenType
                                    });
                                    if (!mValid) continue;
                                }
                                var sourceField = m.from;
                                var destField = m.to;
                                if (sourceField && destField) {
                                    if (
                                        e.rowData === null ||
                                        e.rowData === undefined ||
                                        e.rowData[sourceField] === null ||
                                        e.rowData[sourceField] === undefined
                                    ) {
                                        if (oldData[destField] !== null && oldData[destField] !== undefined) obj[destField] = null;
                                    } else {
                                        if (oldData[destField] !== e.rowData[sourceField]) obj[destField] = e.rowData[sourceField];
                                    }
                                }

                                var setField = m.set;
                                var fieldValue = m.value;
                                if (setField && fieldValue !== undefined) {
                                    obj[setField] = fieldValue;
                                }
                            }
                        }
                        var keys = Object.keys(obj);
                        for (let i = 0; i < keys.length; i++) {
                            const k = keys[i];
                            args.component.itemOption(k, 'value', obj[k]);
                        }

                        // console.log('ant-log-AntDropdownGrid-obj : ',obj);
                        if (keys.length > 0) that.onFieldDataChanged(obj);
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }

        if (args.editorType == 'antDropDownTree') {
            var dataSource = [];

            var url =
                item.options && item.options.url
                    ? item.options.url
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.url
                    ? editorConfig.lookup.url
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.url
                    ? fieldConfig.lookup.url
                    : null;

            var keyField =
                item.options && item.options.keyField
                    ? item.options.keyField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.keyField
                    ? editorConfig.lookup.keyField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.keyField
                    ? fieldConfig.lookup.keyField
                    : null;
            var valueField =
                item.options && item.options.valueField
                    ? item.options.valueField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.valueField
                    ? editorConfig.lookup.valueField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.valueField
                    ? fieldConfig.lookup.valueField
                    : 'code';

            var displayField =
                item.options && item.options.displayField
                    ? item.options.displayField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.displayField
                    ? editorConfig.lookup.displayField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.displayField
                    ? fieldConfig.lookup.displayField
                    : 'name';

            var formDisplayField =
                item.options && item.options.formDisplayField
                    ? item.options.formDisplayField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.formDisplayField
                    ? editorConfig.lookup.formDisplayField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.formDisplayField
                    ? fieldConfig.lookup.formDisplayField
                    : item.displayField;

            if (!formDisplayField) {
                var strField = String(item.dataField).replace('_code', '_name');
                if (strField !== item.dataField) formDisplayField = strField;
                else formDisplayField = item.dataField === 'code' ? 'name' : item.dataField;
            }

            var parentField =
                item.options && item.options.parentField
                    ? item.options.parentField
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.parentField
                    ? editorConfig.lookup.parentField
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.parentField
                    ? fieldConfig.lookup.parentField
                    : null;

            var tableName =
                item.options && item.options.table
                    ? item.options.table
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.table
                    ? editorConfig.lookup.table
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.table
                    ? fieldConfig.lookup.table
                    : null;

            var searchBar =
                item.options && item.options.searchBar !== undefined
                    ? item.options.searchBar
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.searchBar
                    ? editorConfig.lookup.searchBar
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchBar
                    ? fieldConfig.lookup.searchBar
                    : null;

            var columns =
                item.options && item.options.columns
                    ? item.options.columns
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.columns
                    ? editorConfig.lookup.columns
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.columns
                    ? fieldConfig.lookup.columns
                    : undefined;

            var height =
                item.options && item.options.height !== undefined
                    ? item.options.height
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.height
                    ? editorConfig.lookup.height
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.height
                    ? fieldConfig.lookup.height
                    : null;

            if (!height) {
                if (String(item.dataField).endsWith('code')) height = 300;
                else height = 250;
            }

            var width =
                item.options && item.options.width !== undefined
                    ? item.options.width
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.width
                    ? editorConfig.lookup.width
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.width
                    ? fieldConfig.lookup.width
                    : null;

            var actionItems =
                item.options && item.options.actionItems instanceof Array
                    ? item.options.actionItems
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.actionItems instanceof Array
                    ? editorConfig.lookup.actionItems
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.actionItems instanceof Array
                    ? fieldConfig.lookup.actionItems
                    : undefined;

            var mappings =
                item.options && item.options.mapping instanceof Array
                    ? item.options.mapping
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mapping instanceof Array
                    ? editorConfig.lookup.mapping
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mapping instanceof Array
                    ? fieldConfig.lookup.mapping
                    : [];

            var mappingWhen =
                item.options && item.options.mappingWhen instanceof Array
                    ? item.options.mappingWhen
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhen instanceof Array
                    ? editorConfig.lookup.mappingWhen
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhen instanceof Array
                    ? fieldConfig.lookup.mappingWhen
                    : null;

            var mappingWhenType =
                item.options && item.options.mappingWhenType instanceof Array
                    ? item.options.mappingWhenType
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.mappingWhenType instanceof Array
                    ? editorConfig.lookup.mappingWhenType
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.mappingWhenType instanceof Array
                    ? fieldConfig.lookup.mappingWhenType
                    : null;

            var refreshOnOpened =
                item.options && item.options.refreshOnOpened !== undefined
                    ? item.options.refreshOnOpened
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.refreshOnOpened !== undefined
                    ? editorConfig.lookup.refreshOnOpened
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.refreshOnOpened !== undefined
                    ? fieldConfig.lookup.refreshOnOpened
                    : undefined;

            var searchConditions =
                item.options && item.options.searchConditions !== undefined
                    ? item.options.searchConditions
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.searchConditions
                    ? editorConfig.lookup.searchConditions
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.searchConditions
                    ? fieldConfig.lookup.searchConditions
                    : null;

            var lookupClientValues =
                item.options && item.options.values !== undefined
                    ? item.options.values
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.values
                    ? editorConfig.lookup.values
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values
                    ? fieldConfig.lookup.values
                    : null;

            lookupClientValues =
                lookupClientValues instanceof Array && lookupClientValues.length > 0
                    ? lookupClientValues.map((o) => {
                          if (typeof o === 'string') return { code: o };
                          return o;
                      })
                    : typeof lookupClientValues === 'object' && lookupClientValues !== null
                    ? [lookupClientValues]
                    : typeof lookupClientValues === 'string' && lookupClientValues !== null
                    ? [{ code: lookupClientValues }]
                    : [];

            lookupClientValues = lookupClientValues.filter((v) => AntCondition.isVisible(formData, v));

            if (fieldConfig && fieldConfig.lookup && fieldConfig.lookup.values) {
                if (item.options && item.options.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = item.options.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
                if (fieldConfig.lookup && fieldConfig.lookup.values instanceof Array) {
                    lookupClientValues = lookupClientValues.map((o) => {
                        let found = fieldConfig.lookup.values.find((f) => f.code === o.code);
                        if (found) return { ...found, ...o };
                        else return o;
                    });
                }
            }
            var lookupServerName =
                item.options && item.options.lookupServerName !== undefined
                    ? item.options.lookupServerName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.serverName
                    ? editorConfig.lookup.serverName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.serverName
                    ? fieldConfig.lookup.serverName
                    : item.dataField;

            var lookupClientName =
                item.options && item.options.lookupClientName !== undefined
                    ? item.options.lookupClientName
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.clientName
                    ? editorConfig.lookup.clientName
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.clientName
                    ? fieldConfig.lookup.clientName
                    : item.dataField;

            var isRemote =
                item.options && item.options.isRemote !== undefined
                    ? item.options.isRemote
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.isRemote !== undefined
                    ? editorConfig.lookup.isRemote
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.isRemote !== undefined
                    ? fieldConfig.lookup.isRemote
                    : Boolean(url);

            if (!isRemote) {
                if (lookupClientValues) dataSource = lookupClientValues;

                if (formLookups instanceof Array && lookupServerName) {
                    var found = formLookups.find((l) => l.name === lookupServerName);

                    if (found && found.values instanceof Array) {
                        found = JSON.parse(JSON.stringify(found));
                        for (let i = 0; i < found.values.length; i++) {
                            var newValue = found.values[i];
                            if (newValue.code) {
                                var oldValue = dataSource.find((d) => d.code === newValue.code);
                                if (oldValue) {
                                    Object.keys(newValue).forEach((k) => {
                                        if (oldValue[k] === undefined) oldValue[k] = newValue[k];
                                    });
                                } else dataSource.push(newValue);
                            } else dataSource.push(newValue);
                        }
                    }
                }
                if (searchConditions)
                    dataSource = dataSource.filter((value) =>
                        AntCondition.isValid(value, {
                            when: { ...searchConditions }
                        })
                    );

                searchBar = false;
                if (!columns)
                    columns = [
                        {
                            dataField: 'name'
                        }
                    ];
            } else {
                if (!columns)
                    columns = [
                        {
                            dataField: item.dataField
                        }
                    ];
            }

            var isRequired = false;
            if (item.validationRules instanceof Array) isRequired = item.validationRules.find((r) => r.type === 'required');

            var allowNew =
                item.options && item.options.allowNew !== undefined
                    ? item.options.allowNew
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.allowNew !== undefined
                    ? editorConfig.lookup.allowNew
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.allowNew !== undefined
                    ? fieldConfig.lookup.allowNew
                    : false;

            var showClearButton =
                !item.disabled &&
                (item.options && item.options.showClearButton !== undefined
                    ? item.options.showClearButton
                    : editorConfig && editorConfig.lookup && editorConfig.lookup.showClearButton !== undefined
                    ? editorConfig.lookup.showClearButton
                    : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showClearButton !== undefined
                    ? fieldConfig.lookup.showClearButton
                    : !isRequired);

            var showDropDownButton = showClearButton
                ? false
                : !item.disabled &&
                  (item.options && item.options.showDropDownButton !== undefined
                      ? item.options.showDropDownButton
                      : editorConfig && editorConfig.lookup && editorConfig.lookup.showDropDownButton !== undefined
                      ? editorConfig.lookup.showDropDownButton
                      : fieldConfig && fieldConfig.lookup && fieldConfig.lookup.showDropDownButton !== undefined
                      ? fieldConfig.lookup.showDropDownButton
                      : true);
            return (
                <AntDropDownTree
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    formDisplayField={formDisplayField}
                    API={this.props.API}
                    session={this.props.session}
                    url={url}
                    isRemote={isRemote}
                    remotePaging={remotePaging}
                    refreshOnOpened={refreshOnOpened}
                    lookupName={lookupServerName}
                    searchConditions={searchConditions}
                    value={formData ? formData[item.dataField] : null}
                    acceptCustomValue={allowNew}
                    isSearching={item.options && item.options.isSearching !== undefined ? item.options.isSearching : this.props.isSearching}
                    showClearButton={showClearButton}
                    showDropDownButton={showDropDownButton}
                    editorOptions={{
                        stylingMode: item.options && item.options.stylingMode ? item.options.stylingMode : undefined,
                        className: item.options && item.options.className ? item.options.className : undefined
                    }}
                    height={height}
                    width={width}
                    treeOptions={{
                        ...item.options,
                        table: tableName,
                        dataSource: dataSource,
                        keyExpr: keyField,
                        valueExpr: valueField,
                        displayExpr: displayField,
                        parentIdExpr: parentField,
                        columns: columns,
                        searchBar: searchBar,
                        actionItems: actionItems,
                        noDataText: 'Không có dữ liệu'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    getQueryFields={() => {
                        return mappings.map((m) => m.from);
                    }}
                    onValueChanged={(e) => {
                        var oldData = that.state && that.state.oldData ? JSON.parse(JSON.stringify(that.state.oldData)) : {};
                        oldData[item.dataField] = e.value;
                        if (e.rowData && formDisplayField && formDisplayField !== item.dataField) preData[formDisplayField] = e.rowData[displayField];

                        var obj = { [item.dataField]: e.value };
                        if (formDisplayField && formDisplayField !== item.dataField) obj[formDisplayField] = preData[formDisplayField];

                        var isMapping = true;
                        if (mappingWhen && typeof mappingWhen === 'object') {
                            isMapping = AntCondition.isValid(oldData, {
                                when: mappingWhen,
                                whenType: mappingWhenType
                            });
                        }

                        if (isMapping) {
                            for (let i = 0; i < mappings.length; i++) {
                                const m = mappings[i];

                                if (m.when && typeof m.when === 'object') {
                                    var mValid = AntCondition.isValid(oldData, {
                                        when: m.when,
                                        whenType: m.whenType
                                    });
                                    if (!mValid) continue;
                                }

                                var sourceField = m.from;
                                var destField = m.to;
                                if (sourceField && destField) {
                                    if (
                                        e.rowData === null ||
                                        e.rowData === undefined ||
                                        e.rowData[sourceField] === null ||
                                        e.rowData[sourceField] === undefined
                                    ) {
                                        if (oldData[destField] !== null && oldData[destField] !== undefined) obj[destField] = null;
                                    } else {
                                        if (oldData[destField] !== e.rowData[sourceField]) obj[destField] = e.rowData[sourceField];
                                    }
                                }

                                var setField = m.set;
                                var fieldValue = m.value;
                                if (setField && fieldValue !== undefined) {
                                    obj[setField] = fieldValue;
                                }
                            }
                        }
                        var keys = Object.keys(obj);
                        for (let i = 0; i < keys.length; i++) {
                            const k = keys[i];
                            args.component.itemOption(k, 'value', obj[k]);
                        }

                        if (keys.length > 0) that.onFieldDataChanged(obj);
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }

        if (String(item.dataField).endsWith('category1')) {
            return (
                <AntSelectBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    API={this.props.API}
                    session={this.props.session}
                    isRemote={false}
                    useCustomStore={true}
                    defaultValue={formData ? formData[item.dataField] : null}
                    showClearButton={!item.disabled}
                    options={{
                        ...item.options,
                        dataSource: this.CategoryData.getCat1s(),
                        valueExpr: 'code',
                        displayExpr: 'name'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    onValueChanged={(e) => {
                        var cat2Field = String(item.dataField).replace('category1', 'category2');
                        var cat3Field = String(item.dataField).replace('category1', 'category3');

                        that.onFieldDataChanged({
                            [item.dataField]: e.value,
                            [cat2Field]: null,
                            [cat3Field]: null
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }
        if (String(item.dataField).endsWith('category2')) {
            var cat1Field = String(item.dataField).replace('category2', 'category1');
            var cat1Code = formData ? formData[cat1Field] : null;
            return (
                <AntSelectBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    API={this.props.API}
                    session={this.props.session}
                    isRemote={false}
                    useCustomStore={true}
                    defaultValue={formData ? formData[item.dataField] : null}
                    showClearButton={!item.disabled}
                    options={{
                        ...item.options,
                        dataSource: this.CategoryData.getCat2s(cat1Code),
                        valueExpr: 'code',
                        displayExpr: 'name'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    onValueChanged={(e) => {
                        var cat3Field = String(item.dataField).replace('category2', 'category3');

                        that.onFieldDataChanged({
                            [item.dataField]: e.value,
                            [cat3Field]: null
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }
        if (String(item.dataField).endsWith('category3')) {
            var cat2Field = String(item.dataField).replace('category3', 'category2');
            var cat2Code = formData ? formData[cat2Field] : null;

            return (
                <AntSelectBox
                    formRef={this.form}
                    dataSourceHelper={this}
                    dataField={item.dataField}
                    name={this.state.tableName + '_' + item.name}
                    API={this.props.API}
                    session={this.props.session}
                    isRemote={false}
                    useCustomStore={true}
                    defaultValue={formData ? formData[item.dataField] : null}
                    showClearButton={!item.disabled}
                    options={{
                        ...item.options,
                        dataSource: this.CategoryData.getCat3s(cat2Code),
                        valueExpr: 'code',
                        displayExpr: 'name'
                    }}
                    focusStateEnabled={!Boolean(item.disabled)}
                    validationRules={item.disabled ? [] : item.validationRules}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                />
            );
        }

        if (item.dataType === 'float' || item.dataType === 'decimal') {
            var decDigit = item.decimalDigit !== undefined && item.decimalDigit !== null ? item.decimalDigit : 2;
            var strFormat = decDigit > 0 ? '#,##0.' + String('#').repeat(decDigit) : '#,##0';
            if (item.unitType === 'Km') strFormat = strFormat + ' Km';

            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    alignment={'right'}
                    format={strFormat}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType == 'date') {
            var strFormat = item.format;
            if (!strFormat) {
                strFormat = function (value) {
                    if (!value) return '';

                    var unixValue = AntTime.fromDate(value).unix();

                    if (AntTime.isUnixWithinToDay(unixValue))
                        return AntLocalization.translateText({
                            vi: 'Hôm nay',
                            en: 'Today'
                        });

                    if (AntTime.isUnixWithinYesterday(unixValue))
                        return AntLocalization.translateText({
                            vi: 'Hôm qua',
                            en: 'Yesterday'
                        });

                    if (AntTime.isUnixWithinTomorrow(unixValue))
                        return AntLocalization.translateText({
                            vi: 'Ngày mai',
                            en: 'Tomorrow'
                        });

                    if (AntTime.isUnixWithinCurrentYear(unixValue)) return AntTime.fromUnix(unixValue).format('DD/MM');

                    return AntTime.fromUnix(unixValue).format('DD/MM/YYYY');
                };
            }
            return (
                <DateBox
                    showClearButton={true}
                    showAnalogClock={false}
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    alignment={'right'}
                    defaultValue={formData && formData[item.dataField] ? AntTime.fromUnix(formData[item.dataField]).toDate() : null}
                    type={'date'}
                    displayFormat={strFormat}
                    onValueChanged={(e) => {
                        var value = e.value ? AntTime.startOfDay(e.value).unix() : null;

                        that.onFieldDataChanged({
                            [item.dataField]: value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </DateBox>
            );
        }

        if (item.dataType == 'datetime') {
            var strFormat = item.format;
            if (!strFormat) {
                strFormat = function (value) {
                    if (!value) return '';

                    var unixValue = AntTime.fromDate(value).unix();

                    if (AntTime.isUnixWithinToDay(unixValue)) return AntTime.fromUnix(unixValue).format('hh:mm A');

                    // if (AntTime.isUnixWithinYesterday(unixValue)) return 'Hôm qua ' + AntTime.fromUnix(unixValue).format('HH:mm');
                    if (AntTime.isUnixWithinYesterday(unixValue))
                        return AntLocalization.translateText({
                            vi: 'Hôm qua',
                            en: 'Yesterday'
                        });

                    if (AntTime.isUnixWithinTomorrow(unixValue))
                        return AntLocalization.translateText({
                            vi: 'Ngày mai',
                            en: 'Tomorrow'
                        });

                    if (AntTime.isUnixWithinCurrentYear(unixValue)) return AntTime.fromUnix(unixValue).format('DD/MM HH:mm');

                    return AntTime.fromUnix(unixValue).format('DD/MM/YYYY');
                };
            }
            return (
                <DateBox
                    showClearButton={true}
                    showAnalogClock={false}
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    alignment={'right'}
                    defaultValue={formData && formData[item.dataField] ? AntTime.fromUnix(formData[item.dataField]).toDate() : null}
                    type={'datetime'}
                    displayFormat={strFormat}
                    onValueChanged={(e) => {
                        var value = e.value ? AntTime.unix(e.value) : null;

                        that.onFieldDataChanged({
                            [item.dataField]: value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </DateBox>
            );
        }

        if (item.dataType == 'time') {
            return (
                <DateBox
                    showClearButton={true}
                    showAnalogClock={false}
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    alignment={'right'}
                    defaultValue={formData && formData[item.dataField] ? AntTime.fromUnix(formData[item.dataField]).toDate() : null}
                    type={'time'}
                    displayFormat={item.format ? item.format : 'HH:mm'}
                    onValueChanged={(e) => {
                        var value = e.value ? AntTime.timeUnix(AntTime.unix(e.value)) : null;

                        that.onFieldDataChanged({
                            [item.dataField]: value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </DateBox>
            );
        }
        if (item.dataType === 'hour' || (item.dataType == 'int' && item.dataTypeDisplay === 'hour')) {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={'#,##0 giờ'}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }
        if (item.dataType === 'minute' || (item.dataType == 'int' && item.dataTypeDisplay === 'minute')) {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={'#,##0 phút'}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType === 'gram' || (item.dataType == 'int' && item.dataTypeDisplay === 'gram')) {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={'#,##0 gram'}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType === 'day' || (item.dataType == 'int' && item.dataTypeDisplay === 'day')) {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={'#,##0 ngày'}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType == 'int' && item.dataTypeDisplay === 'month') {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={'#,##0 tháng'}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType === 'year' || (item.dataType == 'int' && item.dataTypeDisplay === 'year')) {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={'#,##0 năm'}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType === 'period' || (item.dataType == 'int' && item.dataTypeDisplay === 'period')) {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={'#,##0 kỳ'}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType === 'int' || item.dataType === 'fixedPoint')
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={{ type: 'fixedPoint' }}
                    alignment={'right'}
                    defaultValue={formData ? parseInt(formData[item.dataField]) : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );

        if (item.dataType === 'percent')
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    alignment={'right'}
                    // format={{ type: 'percent', precision: item.decimalDigit }}
                    format={{
                        type: 'percent',
                        precision: item.decimalDigit !== undefined ? item.decimalDigit : 0
                    }}
                    defaultValue={formData ? parseFloat(formData[item.dataField]) : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );

        if (item.dataType === 'currency') {
            return (
                <NumberBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    format={(value) => {
                        return AntLocalization.translateCurrency(
                            value,
                            item.showSign !== undefined
                                ? item.showSign
                                : item.fieldConfig && item.fieldConfig.showSign !== undefined
                                ? item.fieldConfig.showSign
                                : false
                        );
                    }}
                    alignment={'right'}
                    defaultValue={formData ? parseInt(formData[item.dataField]) : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </NumberBox>
            );
        }

        if (item.dataType === 'phone')
            return (
                <TextBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    // mask="(+84) X000 000 000"
                    showMaskMode="onFocus"
                    mask="X000 000 000"
                    maskRules={{ X: /[02-9]/ }}
                    alignment={'right'}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </TextBox>
            );

        if (item.dataType === 'email')
            return (
                <TextBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    mode="email"
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    // onFocusIn={(e) => {
                    //     let inputEl = e.element.querySelector('.dx-texteditor-input');
                    // if (inputEl) {
                    //     inputEl.selectionStart = 0;
                    //     inputEl.selectionEnd = inputEl.value.length;
                    // }
                    // if (that.props.onFocusItem)
                    // that.props.onFocusItem({
                    //     dataField: item.dataField
                    // });
                    // }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </TextBox>
            );

        if (item.editorType === 'antFormLink') {
            return (
                <TextBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    defaultValue={formData ? formData[item.dataField] : null}
                    readOnly={true}
                    disabled={false}
                    hoverStateEnabled={false}
                    focusStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <TextBoxButton
                        name={'btnLink'}
                        location={'after'}
                        options={{
                            icon: 'export',
                            type: 'normal',
                            stylingMode: 'text',
                            hoverStateEnabled: false,
                            focusStateEnabled: false,
                            activeStateEnabled: false,
                            disabled: false,
                            onClick: (e) => {
                                var history = that.config && that.config.session ? that.config.session.history : null;
                                if (history && item.linkUrl && formData && formData[item.dataField]) {
                                    var ar = [];
                                    if (item.linkUrl instanceof Array) {
                                        for (let i = 0; i < item.linkUrl.length; i++) {
                                            ar.push(item.linkUrl[i]);
                                        }
                                    } else if (typeof item.linkUrl === 'object')
                                        ar.push({
                                            when: item.linkUrl.when,
                                            url: item.linkUrl.url,
                                            key: item.linkUrl.key
                                        });
                                    else
                                        ar.push({
                                            url: String(item.linkUrl)
                                        });

                                    for (let i = 0; i < ar.length; i++) {
                                        const ele = ar[i];

                                        var when = ele.when ? ele.when : null;
                                        if (when && typeof when === 'object') {
                                            var isValid = true;

                                            var keys = Object.keys(when);
                                            for (let j = 0; j < keys.length; j++) {
                                                const k = keys[j];
                                                if (formData[k] !== undefined && formData[k] !== when[k]) isValid = false;
                                            }

                                            if (!isValid) continue;
                                        }

                                        var url = ele.url ? ele.url : null;
                                        var key = ele.key ? ele.key : item.dataField;

                                        if (url) {
                                            var link = String(url);
                                            if (!link.startsWith('/')) link = '/' + link;
                                            if (!link.endsWith('/')) link = link + '/';
                                            link = format('{0}{2}', link, null, formData[key]);
                                            history.push(link);
                                        }
                                    }
                                }
                            }
                        }}
                    />
                </TextBox>
            );
        }

        if (args.editorType == 'dxTextBox' || args.editorType === undefined) {
            var mode = 'text';
            if (item.dataType == 'password') mode = 'password';
            return (
                <TextBox
                    {...item.options}
                    name={this.state.tableName + '_' + item.name}
                    focusStateEnabled={!Boolean(item.disabled)}
                    mode={mode}
                    defaultValue={formData ? formData[item.dataField] : null}
                    onValueChanged={(e) => {
                        that.onFieldDataChanged({
                            [item.dataField]: e.value
                        });
                    }}
                    onFocusIn={(e) => {
                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                        if (inputEl) {
                            inputEl.selectionStart = 0;
                            inputEl.selectionEnd = inputEl.value.length;
                        }
                        if (that.props.onFocusItem)
                            that.props.onFocusItem({
                                dataField: item.dataField
                            });
                    }}
                >
                    <Validator validationRules={item.disabled ? [] : item.validationRules} dataField={item.dataField} />
                </TextBox>
            );
        }
    }

    async onFieldDataChanged(args, withoutUpdate) {
        var data = JSON.parse(JSON.stringify(args));
        var changedFields = Object.keys(data);
        var curObj = { ...this.state.formData, ...data };

        if (this.state.items instanceof Array) {
            this.state.items
                .filter(
                    (item) =>
                        item.dataField &&
                        item.options &&
                        item.options.parentFields instanceof Array &&
                        item.options.parentFields.find((pField) => changedFields.includes(pField))
                )
                .forEach((item) => {
                    data[item.dataField] = null;
                });

            var items = this.state.items
                .filter(
                    (item) =>
                        item.dataField &&
                        ((item.formula && item.formula instanceof Array) ||
                            item.dataType === 'join' ||
                            item.dataType === 'fist' ||
                            item.dataType === 'last')
                )
                .map((item, index) => {
                    return {
                        ...item,
                        dataField: item.dataField,
                        formula: item.formula,
                        index: item.formulaIndex !== undefined ? item.formulaIndex : index
                    };
                })
                .sort((a, b) => (a.index > b.index ? 1 : -1));

            items.forEach((item) => {
                var value;

                if (item.formula instanceof Array) {
                    var fm = item.formula[0];
                    var defaultNullValue =
                        item.formula[1] !== undefined && item.formula[1] !== null && typeof item.formula[1] === 'number' ? item.formula[1] : 0;
                    value = Calculator.execNum(curObj, fm, defaultNullValue);
                } else if (item.dataType === 'join') {
                    var fields = item.fields;
                    if (fields instanceof Array) {
                        value = fields
                            .map((f) => {
                                if (!curObj) return null;

                                if (f === 'category1') {
                                    var cat1 = this.CategoryData.getCat1(curObj[f]);
                                    if (cat1) return AntLocalization.translateText(cat1.name);
                                }
                                if (f === 'category2') {
                                    var cat2 = this.CategoryData.getCat2(curObj[f]);
                                    if (cat2) return AntLocalization.translateText(cat2.name);
                                }
                                if (f === 'category3') {
                                    var cat3 = this.CategoryData.getCat3(curObj[f]);
                                    if (cat3) return AntLocalization.translateText(cat3.name);
                                }

                                return curObj[f];
                            })

                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .join(item.separator ? item.separator : ', ');
                    }
                } else if (item.dataType === 'first') {
                    var fields = item.fields;
                    if (fields instanceof Array) {
                        value = fields
                            .map((f) => {
                                if (!curObj) return null;

                                if (f === 'category1') {
                                    var cat1 = this.CategoryData.getCat1(curObj[f]);
                                    if (cat1) return AntLocalization.translateText(cat1.name);
                                }
                                if (f === 'category2') {
                                    var cat2 = this.CategoryData.getCat2(curObj[f]);
                                    if (cat2) return AntLocalization.translateText(cat2.name);
                                }
                                if (f === 'category3') {
                                    var cat3 = this.CategoryData.getCat3(curObj[f]);
                                    if (cat3) return AntLocalization.translateText(cat3.name);
                                }

                                return curObj[f];
                            })
                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .shift();
                    }
                } else if (item.dataType === 'last') {
                    var fields = item.fields;
                    if (fields instanceof Array) {
                        value = fields
                            .map((f) => {
                                if (!curObj) return null;

                                if (f === 'category1') {
                                    var cat1 = this.CategoryData.getCat1(curObj[f]);
                                    if (cat1) return AntLocalization.translateText(cat1.name);
                                }
                                if (f === 'category2') {
                                    var cat2 = this.CategoryData.getCat2(curObj[f]);
                                    if (cat2) return AntLocalization.translateText(cat2.name);
                                }
                                if (f === 'category3') {
                                    var cat3 = this.CategoryData.getCat3(curObj[f]);
                                    if (cat3) return AntLocalization.translateText(cat3.name);
                                }

                                return curObj[f];
                            })
                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .pop();
                    }
                }

                if (value !== undefined) {
                    curObj[item.dataField] = value;
                    // if (value !== data[item.dataField])

                    data[item.dataField] = value;
                }
            });
        }

        if (Object.keys(data).length > 0) {
            this.setState((state) => {
                Object.keys(data).forEach((f) => {
                    state.formData[f] = data[f];
                });
                return state;
            });

            await this.resetUI(withoutUpdate);
            if (!withoutUpdate && this.props.onFieldDataChanged) this.props.onFieldDataChanged(data);
        }
        if (this.onError) this.onError(null);
    }

    async onAction(button) {
        var error = null;
        if (button && button.id == 'btnSave') {
            this.state.actionStatus = 'Saving';
            var valid = await this.validate();
            if (!valid) {
                this.state.actionStatus = null;
                return false;
            }

            var newObj = this.getChangedFields();

            if (newObj && typeof newObj === 'object' && Object.keys(newObj).length > 0) {
                if (this.props.onSaving) newObj = this.props.onSaving(this.state.formData, newObj);

                if (!newObj || Object.keys(newObj).length === 0) {
                    this.state.actionStatus = null;
                    return true;
                } else {
                    var result = await this.API.postUpdateValidation(
                        {
                            id: this.getId(),
                            checksum: this.getChecksum()
                        },
                        newObj
                    );
                    error = this.config.translateFirstError(result, 'Dữ liệu không hợp lệ!');

                    if (!error) {
                        var result = await this.API.postUpdate(
                            {
                                id: this.getId(),
                                checksum: this.getChecksum()
                            },
                            newObj
                        );
                        if (!result || result.error || !result.data || !result.data.updated)
                            error = this.config.translateFirstError(result, 'Dữ liệu không hợp lệ!');
                    }
                }
                if (error) {
                    if (this.props.onError) this.props.onError('Không thể cập nhật thông tin !', error);
                    {
                        this.state.actionStatus = null;
                        return false;
                    }
                } else if (this.props.onSaved) this.props.onSaved(result.data);
            }
        }
        this.state.actionStatus = null;
        return true;
    }

    focusToItem(fieldName) {
        if (fieldName && this.form) {
            if (this.state.rawItems instanceof Array) {
                for (let i = 0; i < this.state.rawItems.length; i++) {
                    const item = this.state.rawItems[i];

                    if (item.dataField === fieldName) {
                        var itemName = item.name ? item.name : item.dataField;
                        var itemPath = item && item.groupName ? item.groupName + '.' + itemName : null;

                        var grouplabel = item.groupLabel;

                        if (item.groupLabel) {
                            if (item.groupLabel instanceof Array) {
                                grouplabel = AntCondition.getValue(this.state.formData, item.groupLabel);
                                grouplabel = AntLocalization.translateText(grouplabel);
                            }
                        }

                        if (!itemPath) itemPath = item && item.groupLabel ? item.groupLabel + '.' + itemName : null;
                        if (!itemPath) itemPath = itemName;

                        // var formItem = this.form.getEditor(itemName);
                        var formItem = $("[name='" + this.state.tableName + '_' + itemName + "'")[0];
                        if (formItem) {
                            // formItem = formItem.dxTextBox('instance');
                            formItem.focus();

                            // this.form.updateDimensions();
                        }
                    }
                }
            }
        }
    }

    render() {
        this.initItems();
        var that = this;

        var getItem = (items) => {
            if (items instanceof Array) {
                var ar = [];
                items.forEach((e) => {
                    var colSpan = AntCondition.getValue(this.state.formData, e.colSpan);
                    if (colSpan === undefined) colSpan = e.colSpanDefault;

                    var colCount = AntCondition.getValue(this.state.formData, e.colCount);
                    if (colCount === undefined) colCount = e.colCountDefault;

                    var label = AntCondition.getValue(this.state.formData, e.label);
                    label = AntLocalization.translateText(label);

                    if (e.items instanceof Array && e.itemType === 'group') {
                        let gItems = getItem(e.items);
                        // let gVisible = gItems.length > 0 && that.isVisibleField(e);

                        if (gItems.length > 0)
                            ar.push({
                                itemType: 'group',
                                caption: label,
                                name: e.name,
                                colSpan: colSpan,
                                colCount: colCount,
                                items: gItems,
                                visible: that.isVisibleField(e)
                            });
                    } else if (e.itemType === 'empty')
                        ar.push({
                            itemType: 'empty',
                            colCount: colCount,
                            colSpan: colSpan,
                            visible: that.isVisibleField(e)
                        });
                    else {
                        var item = that.state.items.find((item) => (e.name ? item.name === e.name : item.dataField === e.dataField));
                        if (item && item.render !== false)
                            ar.push({
                                ...item,
                                colSpan: colSpan,
                                colCount: colCount,
                                visible: that.isVisibleField(e)
                            });
                    }
                });
            }
            return ar;
        };

        var items = [];
        if (this.props.items instanceof Array) items = getItem(this.props.items);

        if (this.props.inMultipleTabs) {
            if (items.filter((i) => i.itemType === 'group').length === 1) {
                var found = items.find((i) => i.caption);
                if (found) found.caption = undefined;
            }
        }

        var colCount = AntCondition.getValue(this.state.formData, this.props.colCount);
        if (colCount === undefined) colCount = this.props.colCountDefault;

        return (
            <React.Fragment>
                <ValidationGroup
                    ref={(ref) => {
                        this.group = ref ? ref.instance : undefined;
                    }}
                >
                    <Form
                        className="ant-form"
                        ref={(ref) => {
                            that.form = ref ? ref.instance : undefined;
                        }}
                        labelLocation={this.props.labelLocation ? this.props.labelLocation : 'left'}
                        alignItemLabelsInAllGroups={
                            this.props.alignItemLabelsInAllGroups !== undefined ? this.props.alignItemLabelsInAllGroups : true
                        }
                        formData={this.state.formData}
                        colCount={colCount}
                        visible={this.props.visible !== undefined ? this.props.visible : true}
                        // disabled={this.props.disabled !== undefined ? this.props.disabled : false}
                        items={items}
                        // disabled={!this.state.edit || !this.state.edit.isEditable}
                        onContentReady={(e) => {
                            setTimeout(() => {
                                if (that.props.onContentReady) that.props.onContentReady();
                                // if (that.props.currentFocusedField) that.focusToItem(that.props.currentFocusedField);
                            });
                        }}
                    >
                        <Template name={'renderItem'} render={this.renderItem.bind(this)} />
                    </Form>
                </ValidationGroup>
            </React.Fragment>
        );
    }
}
